import { t as y, e as D, f as G, m as O, o as Yt, p as An, d as V, q as Tn, u as te, v as ze, w as at, n as yt, x as Ke, y as Fn, z as En, A as Vn, a as b, S as K, B as Se, C as mt, D as jn, i as h, l as ut, c as Ht, E as Pe, G as Je, H as ct, F as it, I as de, J as xe, g as Ge, b as Ze, M as jt, K as Dn, L as Rn, h as Ln, N as he, r as Mn, O as Bn } from "./__packages__deps__web-929faed1.js";
import { g as Dt, a as On, m as xt, c as Hn, s as Wn } from "./__packages__deps__getCurrentProduct-c133e537.js";
import { i as qn, a as Un, c as Xe } from "./__packages__deps__validate-customization-2bfb56fe.js";
import { m as _, g as It, b as Qe, a as Kn, c as Jn } from "./__packages__deps__queryProductByHandle-018098bd.js";
const Gn = /* @__PURE__ */ y(`<style>
          .loader-customization-widget {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background-color: #000;
            box-shadow: 32px 0 #000, -32px 0 #000;
            position: relative;
            animation: flash 0.5s ease-out infinite alternate;
          }
          
          @keyframes flash {
            0% {
              background-color: #FFF2;
              box-shadow: 32px 0 #FFF2, -32px 0 #000;
            }
            50% {
              background-color: #000;
              box-shadow: 32px 0 #FFF2, -32px 0 #FFF2;
            }
            100% {
              background-color: #FFF2;
              box-shadow: 32px 0 #000, -32px 0 #FFF2;
            }
          }
        </style>`), Zn = /* @__PURE__ */ y('<span class="loader-customization-widget tw-mx-[32px]"></span>'), pe = () => [Gn.cloneNode(!0), Zn.cloneNode(!0)], Xn = /* @__PURE__ */ y('<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"></path></svg>'), Ye = (t) => (() => {
  const e = Xn.cloneNode(!0);
  return D(() => G(e, "class", t.class)), e;
})();
function Qn(t, e, s) {
  return t.addEventListener(e, s), () => t.removeEventListener(e, s);
}
function Yn([t, e], s, r) {
  return [s ? () => s(t()) : t, r ? (n) => e(r(n)) : e];
}
function tr(t) {
  try {
    return document.querySelector(t);
  } catch {
    return null;
  }
}
function er(t, e) {
  const s = tr(`#${t}`);
  s ? s.scrollIntoView() : e && window.scrollTo(0, 0);
}
function tn(t, e, s, r) {
  let n = !1;
  const o = (l) => typeof l == "string" ? { value: l } : l, i = Yn(O(o(t()), { equals: (l, a) => l.value === a.value }), void 0, (l) => (!n && e(l), l));
  return s && Yt(s((l = t()) => {
    n = !0, i[1](o(l)), n = !1;
  })), {
    signal: i,
    utils: r
  };
}
function nr(t) {
  if (t) {
    if (Array.isArray(t))
      return {
        signal: t
      };
  } else
    return {
      signal: O({ value: "" })
    };
  return t;
}
function rr() {
  return tn(() => ({
    value: window.location.pathname + window.location.search + window.location.hash,
    state: history.state
  }), ({ value: t, replace: e, scroll: s, state: r }) => {
    e ? window.history.replaceState(r, "", t) : window.history.pushState(r, "", t), er(window.location.hash.slice(1), s);
  }, (t) => Qn(window, "popstate", () => t()), {
    go: (t) => window.history.go(t)
  });
}
function sr() {
  let t = /* @__PURE__ */ new Set();
  function e(n) {
    return t.add(n), () => t.delete(n);
  }
  let s = !1;
  function r(n, o) {
    if (s)
      return !(s = !1);
    const i = {
      to: n,
      options: o,
      defaultPrevented: !1,
      preventDefault: () => i.defaultPrevented = !0
    };
    for (const l of t)
      l.listener({
        ...i,
        from: l.location,
        retry: (a) => {
          a && (s = !0), l.navigate(n, o);
        }
      });
    return !i.defaultPrevented;
  }
  return {
    subscribe: e,
    confirm: r
  };
}
const or = /^(?:[a-z0-9]+:)?\/\//i, ir = /^\/+|\/+$/g;
function Kt(t, e = !1) {
  const s = t.replace(ir, "");
  return s ? e || /^[?#]/.test(s) ? s : "/" + s : "";
}
function ie(t, e, s) {
  if (or.test(e))
    return;
  const r = Kt(t), n = s && Kt(s);
  let o = "";
  return !n || e.startsWith("/") ? o = r : n.toLowerCase().indexOf(r.toLowerCase()) !== 0 ? o = r + n : o = n, (o || "/") + Kt(e, !o);
}
function ar(t, e) {
  if (t == null)
    throw new Error(e);
  return t;
}
function en(t, e) {
  return Kt(t).replace(/\/*(\*.*)?$/g, "") + Kt(e);
}
function lr(t) {
  const e = {};
  return t.searchParams.forEach((s, r) => {
    e[r] = s;
  }), e;
}
function nn(t, e, s) {
  const [r, n] = t.split("/*", 2), o = r.split("/").filter(Boolean), i = o.length;
  return (l) => {
    const a = l.split("/").filter(Boolean), u = a.length - i;
    if (u < 0 || u > 0 && n === void 0 && !e)
      return null;
    const d = {
      path: i ? "" : "/",
      params: {}
    }, c = (p) => s === void 0 ? void 0 : s[p];
    for (let p = 0; p < i; p++) {
      const f = o[p], w = a[p], g = f[0] === ":" ? f.slice(1) : f;
      if (f[0] === ":" && be(w, c(g)))
        d.params[g] = w;
      else if (!be(w, f))
        return null;
      d.path += `/${w}`;
    }
    if (n) {
      const p = u ? a.slice(-u).join("/") : "";
      if (be(p, c(n)))
        d.params[n] = p;
      else
        return null;
    }
    return d;
  };
}
function be(t, e) {
  const s = (r) => r.localeCompare(t, void 0, { sensitivity: "base" }) === 0;
  return e === void 0 ? !0 : typeof e == "string" ? s(e) : typeof e == "function" ? e(t) : Array.isArray(e) ? e.some(s) : e instanceof RegExp ? e.test(t) : !1;
}
function cr(t) {
  const [e, s] = t.pattern.split("/*", 2), r = e.split("/").filter(Boolean);
  return r.reduce((n, o) => n + (o.startsWith(":") ? 2 : 3), r.length - (s === void 0 ? 0 : 1));
}
function rn(t) {
  const e = /* @__PURE__ */ new Map(), s = Tn();
  return new Proxy({}, {
    get(r, n) {
      return e.has(n) || An(s, () => e.set(n, V(() => t()[n]))), e.get(n)();
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    },
    ownKeys() {
      return Reflect.ownKeys(t());
    }
  });
}
function Ne(t) {
  let e = /(\/?\:[^\/]+)\?/.exec(t);
  if (!e)
    return [t];
  let s = t.slice(0, e.index), r = t.slice(e.index + e[0].length);
  const n = [s, s += e[1]];
  for (; e = /^(\/\:[^\/]+)\?/.exec(r); )
    n.push(s += e[1]), r = r.slice(e[0].length);
  return Ne(r).reduce((o, i) => [...o, ...n.map((l) => l + i)], []);
}
const ur = 100, sn = ze(), ge = ze(), me = () => ar(te(sn), "Make sure your app is wrapped in a <Router />");
let Jt;
const fe = () => Jt || te(ge) || me().base, dt = () => me().navigatorFactory(), ee = () => me().location, dr = (t, e) => {
  const s = ee(), r = V(() => Ne(t()).map((n) => nn(n, void 0, e)));
  return V(() => {
    for (const n of r()) {
      const o = n(s.pathname);
      if (o)
        return o;
    }
  });
}, on = () => fe().params, zt = () => fe().data;
function pr(t, e = "", s) {
  const { component: r, data: n, children: o } = t, i = !o || Array.isArray(o) && !o.length, l = {
    key: t,
    element: r ? () => b(r, {}) : () => {
      const { element: a } = t;
      return a === void 0 && s ? b(s, {}) : a;
    },
    preload: t.component ? r.preload : t.preload,
    data: n
  };
  return an(t.path).reduce((a, u) => {
    for (const d of Ne(u)) {
      const c = en(e, d), p = i ? c : c.split("/*", 1)[0];
      a.push({
        ...l,
        originalPath: d,
        pattern: p,
        matcher: nn(p, !i, t.matchFilters)
      });
    }
    return a;
  }, []);
}
function gr(t, e = 0) {
  return {
    routes: t,
    score: cr(t[t.length - 1]) * 1e4 - e,
    matcher(s) {
      const r = [];
      for (let n = t.length - 1; n >= 0; n--) {
        const o = t[n], i = o.matcher(s);
        if (!i)
          return null;
        r.unshift({
          ...i,
          route: o
        });
      }
      return r;
    }
  };
}
function an(t) {
  return Array.isArray(t) ? t : [t];
}
function ln(t, e = "", s, r = [], n = []) {
  const o = an(t);
  for (let i = 0, l = o.length; i < l; i++) {
    const a = o[i];
    if (a && typeof a == "object" && a.hasOwnProperty("path")) {
      const u = pr(a, e, s);
      for (const d of u) {
        r.push(d);
        const c = Array.isArray(a.children) && a.children.length === 0;
        if (a.children && !c)
          ln(a.children, d.pattern, s, r, n);
        else {
          const p = gr([...r], n.length);
          n.push(p);
        }
        r.pop();
      }
    }
  }
  return r.length ? n : n.sort((i, l) => l.score - i.score);
}
function mr(t, e) {
  for (let s = 0, r = t.length; s < r; s++) {
    const n = t[s].matcher(e);
    if (n)
      return n;
  }
  return [];
}
function fr(t, e) {
  const s = new URL("http://sar"), r = V((a) => {
    const u = t();
    try {
      return new URL(u, s);
    } catch {
      return console.error(`Invalid path ${u}`), a;
    }
  }, s, {
    equals: (a, u) => a.href === u.href
  }), n = V(() => r().pathname), o = V(() => r().search, !0), i = V(() => r().hash), l = V(() => "");
  return {
    get pathname() {
      return n();
    },
    get search() {
      return o();
    },
    get hash() {
      return i();
    },
    get state() {
      return e();
    },
    get key() {
      return l();
    },
    query: rn(Ke(o, () => lr(r())))
  };
}
function wr(t, e = "", s, r) {
  const { signal: [n, o], utils: i = {} } = nr(t), l = i.parsePath || ((N) => N), a = i.renderPath || ((N) => N), u = i.beforeLeave || sr(), d = ie("", e), c = void 0;
  if (d === void 0)
    throw new Error(`${d} is not a valid base path`);
  d && !n().value && o({ value: d, replace: !0, scroll: !1 });
  const [p, f] = O(!1), w = async (N) => {
    f(!0);
    try {
      await Fn(N);
    } finally {
      f(!1);
    }
  }, [g, v] = O(n().value), [k, I] = O(n().state), P = fr(g, k), $ = [], S = {
    pattern: d,
    params: {},
    path: () => d,
    outlet: () => null,
    resolvePath(N) {
      return ie(d, N);
    }
  };
  if (s)
    try {
      Jt = S, S.data = s({
        data: void 0,
        params: {},
        location: P,
        navigate: H(S)
      });
    } finally {
      Jt = void 0;
    }
  function j(N, T, m) {
    at(() => {
      if (typeof T == "number") {
        T && (i.go ? u.confirm(T, m) && i.go(T) : console.warn("Router integration does not support relative routing"));
        return;
      }
      const { replace: x, resolve: z, scroll: R, state: B } = {
        replace: !1,
        resolve: !0,
        scroll: !0,
        ...m
      }, A = z ? N.resolvePath(T) : ie("", T);
      if (A === void 0)
        throw new Error(`Path '${T}' is not a routable path`);
      if ($.length >= ur)
        throw new Error("Too many redirects");
      const L = g();
      if ((A !== L || B !== k()) && !En) {
        if (u.confirm(A, m)) {
          const W = $.push({ value: L, replace: x, scroll: R, state: k() });
          w(() => {
            v(A), I(B), Vn();
          }).then(() => {
            $.length === W && X({
              value: A,
              state: B
            });
          });
        }
      }
    });
  }
  function H(N) {
    return N = N || te(ge) || S, (T, m) => j(N, T, m);
  }
  function X(N) {
    const T = $[0];
    T && ((N.value !== T.value || N.state !== T.state) && o({
      ...N,
      replace: T.replace,
      scroll: T.scroll
    }), $.length = 0);
  }
  D(() => {
    const { value: N, state: T } = n();
    at(() => {
      N !== g() && w(() => {
        v(N), I(T);
      });
    });
  });
  {
    let N = function(T) {
      if (T.defaultPrevented || T.button !== 0 || T.metaKey || T.altKey || T.ctrlKey || T.shiftKey)
        return;
      const m = T.composedPath().find((L) => L instanceof Node && L.nodeName.toUpperCase() === "A");
      if (!m || !m.hasAttribute("link"))
        return;
      const x = m.href;
      if (m.target || !x && !m.hasAttribute("state"))
        return;
      const z = (m.getAttribute("rel") || "").split(/\s+/);
      if (m.hasAttribute("download") || z && z.includes("external"))
        return;
      const R = new URL(x);
      if (R.origin !== window.location.origin || d && R.pathname && !R.pathname.toLowerCase().startsWith(d.toLowerCase()))
        return;
      const B = l(R.pathname + R.search + R.hash), A = m.getAttribute("state");
      T.preventDefault(), j(S, B, {
        resolve: !1,
        replace: m.hasAttribute("replace"),
        scroll: !m.hasAttribute("noscroll"),
        state: A && JSON.parse(A)
      });
    };
    yt(["click"]), document.addEventListener("click", N), Yt(() => document.removeEventListener("click", N));
  }
  return {
    base: S,
    out: c,
    location: P,
    isRouting: p,
    renderPath: a,
    parsePath: l,
    navigatorFactory: H,
    beforeLeave: u
  };
}
function hr(t, e, s, r, n) {
  const { base: o, location: i, navigatorFactory: l } = t, { pattern: a, element: u, preload: d, data: c } = r().route, p = V(() => r().path);
  d && d();
  const f = {
    parent: e,
    pattern: a,
    get child() {
      return s();
    },
    path: p,
    params: n,
    data: e.data,
    outlet: u,
    resolvePath(w) {
      return ie(o.path(), w, p());
    }
  };
  if (c)
    try {
      Jt = f, f.data = c({ data: e.data, params: n, location: i, navigate: l(f) });
    } finally {
      Jt = void 0;
    }
  return f;
}
const br = (t) => {
  const {
    source: e,
    url: s,
    base: r,
    data: n,
    out: o
  } = t, i = e || rr(), l = wr(i, r, n);
  return b(sn.Provider, {
    value: l,
    get children() {
      return t.children;
    }
  });
}, cn = (t) => {
  const e = me(), s = fe(), r = Se(() => t.children), n = V(() => ln(r(), en(s.pattern, t.base || ""), un)), o = V(() => mr(n(), e.location.pathname)), i = rn(() => {
    const d = o(), c = {};
    for (let p = 0; p < d.length; p++)
      Object.assign(c, d[p].params);
    return c;
  });
  e.out && e.out.matches.push(o().map(({
    route: d,
    path: c,
    params: p
  }) => ({
    originalPath: d.originalPath,
    pattern: d.pattern,
    path: c,
    params: p
  })));
  const l = [];
  let a;
  const u = V(Ke(o, (d, c, p) => {
    let f = c && d.length === c.length;
    const w = [];
    for (let g = 0, v = d.length; g < v; g++) {
      const k = c && c[g], I = d[g];
      p && k && I.route.key === k.route.key ? w[g] = p[g] : (f = !1, l[g] && l[g](), jn((P) => {
        l[g] = P, w[g] = hr(e, w[g - 1] || s, () => u()[g + 1], () => o()[g], i);
      }));
    }
    return l.splice(d.length).forEach((g) => g()), p && f ? p : (a = w[0], w);
  }));
  return b(K, {
    get when() {
      return u() && a;
    },
    children: (d) => b(ge.Provider, {
      value: d,
      get children() {
        return d.outlet();
      }
    })
  });
}, _r = (t, e) => () => b(cn, {
  base: e,
  children: t
}), vr = (t) => {
  const e = Se(() => t.children);
  return mt(t, {
    get children() {
      return e();
    }
  });
}, un = () => {
  const t = fe();
  return b(K, {
    get when() {
      return t.child;
    },
    children: (e) => b(ge.Provider, {
      value: e,
      get children() {
        return e.outlet();
      }
    })
  });
}, yr = /* @__PURE__ */ y('<button class="tw-typ-body-1 tw-flex tw-w-full tw-items-center tw-gap-3"><span></span></button>'), $r = () => {
  const t = dt();
  return (() => {
    const e = yr.cloneNode(!0), s = e.firstChild;
    return e.$$click = () => t(-1), h(s, b(Ye, {
      class: "tw-h-full tw-w-4 tw-rotate-180"
    })), h(e, () => window.customizationProduct.translations.buttons["customization-back-button"], null), e;
  })();
};
yt(["click"]);
const ae = (t) => {
  const e = document.getElementById("customization-drawer"), s = {
    open: "add",
    close: "remove",
    toggle: "toggle"
  };
  t === "toggle" && e.classList.contains("open") ? document.body.classList.remove("tw-overflow-hidden") : t === "toggle" ? document.body.classList.add("tw-overflow-hidden") : document.body.classList[s[t]]("tw-overflow-hidden"), e.classList[s[t]]("open");
}, xr = /* @__PURE__ */ y('<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"></path></svg>'), kr = (t) => (() => {
  const e = xr.cloneNode(!0);
  return D(() => G(e, "class", t.class)), e;
})(), Ir = /* @__PURE__ */ y('<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"></path></svg>'), zr = (t) => (() => {
  const e = Ir.cloneNode(!0);
  return D(() => G(e, "class", t.class)), e;
})();
function Gt(t) {
  return (e) => {
    const s = t.safeParse(e);
    return s.success ? "" : s.error.issues[0].message;
  };
}
function St(t) {
  return (e) => {
    const s = t.safeParse(e);
    return s.success ? {} : s.error.issues.reduce((r, n) => {
      const o = n.path.join(".");
      return r[o] || (r[o] = n.message), r;
    }, {});
  };
}
function Pt(t = {}) {
  const { initialValues: e = {}, validateOn: s = "submit", revalidateOn: r = "input", validate: n } = t, o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), [l, a] = O([]), [u, d] = O([]), [c, p] = O(), [f, w] = O(0), [g, v] = O(!1), [k, I] = O(!1), [P, $] = O(!1), [S, j] = O(!1), [H, X] = O(!1), [N, T] = O(!1), [m, x] = O({});
  return {
    internal: {
      validators: /* @__PURE__ */ new Set(),
      initialValues: e,
      validateOn: s,
      revalidateOn: r,
      validate: n,
      fields: o,
      fieldArrays: i,
      getFieldNames: l,
      setFieldNames: a,
      getFieldArrayNames: u,
      setFieldArrayNames: d,
      setElement: p,
      setSubmitCount: w,
      setSubmitting: v,
      setSubmitted: I,
      setValidating: $,
      setTouched: j,
      setDirty: X,
      setInvalid: T,
      setResponse: x
    },
    get element() {
      return c();
    },
    get submitCount() {
      return f();
    },
    get submitting() {
      return g();
    },
    get submitted() {
      return k();
    },
    get validating() {
      return P();
    },
    get touched() {
      return S();
    },
    get dirty() {
      return H();
    },
    get invalid() {
      return N();
    },
    get response() {
      return m();
    }
  };
}
function Ve(t, e) {
  const { checked: s, files: r, multiple: n, options: o, type: i, value: l } = t, a = () => at(e.getInput);
  let u, d;
  return i === "number" || i === "range" ? (
    // Return values as number
    (u = a(), d = parseFloat(l), u === void 0 || !isNaN(d) ? d : u)
  ) : i === "checkbox" ? l && l !== "on" ? (
    // Return value as array of string
    s ? [...a() || [], l] : (a() || []).filter((c) => c !== l)
  ) : (
    // Return value as boolean
    s
  ) : i === "file" ? n ? (
    // Return value as file list
    r
  ) : (
    // Return value as single file
    r == null ? void 0 : r[0]
  ) : o && n ? (
    // Return value as array of strings
    [...o].filter((c) => c.selected && !c.disabled).map((c) => c.value)
  ) : (
    // Return value as string
    l
  );
}
function le(t, e) {
  return t && e ? t.split(".").reduce((s, r) => s == null ? void 0 : s[r], e) : e;
}
function dn(t, e) {
  return le(e, t.internal.initialValues);
}
function Nt(t, e, s = {}) {
  const { initialValue: r, validate: n = [] } = s;
  let o = t.internal.fields.get(e);
  if (o)
    s.validate && (t.internal.fields.set(e, { ...o, validate: n }), o.validate = n);
  else {
    const i = r ? r[0] : dn(t, e), [l, a] = O([]), [u, d] = O(i), [c, p] = O(i), [f, w] = O(""), [g, v] = O(!1), [k, I] = O(!1), [P, $] = O(!1);
    o = {
      consumers: /* @__PURE__ */ new Set(),
      getElements: l,
      setElements: a,
      getInitialInput: u,
      setInitialInput: d,
      getInput: c,
      setInput: p,
      getError: f,
      setError: w,
      getActive: g,
      setActive: v,
      getTouched: k,
      setTouched: I,
      getDirty: P,
      setDirty: $,
      validate: n
    }, t.internal.fields.set(e, o), t.internal.setFieldNames((S) => [...S, e]);
  }
  return o;
}
let Sr = 0;
function Lt() {
  return Sr++;
}
function pn(t, e) {
  return (le(e, t.internal.initialValues) || []).map(() => Lt());
}
function Mt(t, e, s = {}) {
  const { validate: r = [] } = s;
  let n = t.internal.fieldArrays.get(e);
  if (n)
    s.validate && (t.internal.fieldArrays.set(e, { ...n, validate: r }), n.validate = r);
  else {
    const o = pn(t, e), [i, l] = O(o), [a, u] = O(o), [d, c] = O(""), [p, f] = O(!1), [w, g] = O(!1), [v, k] = O(!1);
    n = {
      consumers: /* @__PURE__ */ new Set(),
      getInitialItems: i,
      setInitialItems: l,
      getItems: a,
      setItems: u,
      getError: d,
      setError: c,
      getActive: p,
      setActive: f,
      getTouched: w,
      setTouched: g,
      getDirty: v,
      setDirty: k,
      validate: r
    }, t.internal.fieldArrays.set(e, n), t.internal.setFieldArrayNames((I) => [
      ...I,
      e
    ]);
  }
  return n;
}
function Pr(t, e, s) {
  const { initialValue: r, replacePrefix: n, shouldActive: o, shouldTouched: i, shouldDirty: l, shouldValid: a } = s;
  return e.reduce((u, d) => {
    const c = Nt(t, d);
    return (!o || c.getActive()) && (!i || c.getTouched()) && (!l || c.getDirty()) && (!a || !c.getError()) && (n ? d.replace(n, "") : d).split(".").reduce((p, f, w, g) => {
      const v = p[f], k = w === g.length - 1 ? c.getInput() : (
        // Otherwise use current value or an empty object or array
        v && typeof v == "object" ? v : isNaN(+g[w + 1]) ? {} : []
      );
      return p[f] = k, p[f];
    }, u), u;
  }, r);
}
function Ce(t, e) {
  const s = at(t.internal.getFieldNames), r = at(t.internal.getFieldArrayNames);
  return typeof e == "string" || Array.isArray(e) ? (typeof e == "string" ? [e] : e).reduce((n, o) => {
    const [i, l] = n;
    return t.internal.fields.has(o) ? i.add(o) : t.internal.fieldArrays.has(o) && (r.forEach((a) => {
      a.startsWith(o) && l.add(a);
    }), s.forEach((a) => {
      a.startsWith(o) && i.add(a);
    })), n;
  }, [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]).map((n) => [...n]) : [s, r];
}
function Ae(t, e) {
  return (typeof t != "string" && !Array.isArray(t) ? t : e) || {};
}
function _e(t, e) {
  return +e.replace(`${t}.`, "").split(".")[0];
}
function gn(t) {
  return typeof t == "function" ? [t] : t || [];
}
function Nr(t, e) {
  t.setInitialItems(e.initialItems), t.setItems(e.items), t.setError(e.error), t.setTouched(e.touched), t.setDirty(e.dirty);
}
function Cr(t, e) {
  t.setElements(e.elements), t.setInitialInput(() => e.initialInput), t.setInput(() => e.input), t.setError(e.error), t.setTouched(e.touched), t.setDirty(e.dirty);
}
function mn(t, e, s) {
  e.split(".").reduce((r, n, o, i) => typeof r == "object" && o === i.length - 1 ? r[n] = s : typeof r[n] == "object" ? r[n] : isNaN(+n) ? r[n] = {} : r[n] = [], t.internal.initialValues);
}
function Ar(t, e) {
  at(() => {
    t.internal.setDirty(e || [...t.internal.fields, ...t.internal.fieldArrays].some(([, s]) => s.getActive() && s.getDirty()));
  });
}
function Te(t, e) {
  at(() => {
    const s = e.getInitialInput(), r = e.getInput(), n = Array.isArray(s) && Array.isArray(r) ? s.join() !== r.join() : typeof s == "number" && typeof r == "number" && isNaN(s) && isNaN(r) ? !1 : s !== r;
    ut(() => {
      e.setDirty(n), Ar(t, n);
    });
  });
}
function ce(t, e, s, r) {
  at(() => {
    const { on: n, shouldFocus: o = !1 } = r;
    n.includes((t.internal.validateOn === "submit" ? t.submitted : e.getError()) ? t.internal.revalidateOn : t.internal.validateOn) && fn(t, s, { shouldFocus: o });
  });
}
function je(t, e, s, r) {
  ut(() => {
    e.setInput(() => r), e.setTouched(!0), t.internal.setTouched(!0), Te(t, e), ce(t, e, s, { on: ["touched", "input"] });
  });
}
function ke(t) {
  let e = !1, s = !1, r = !1;
  at(() => {
    for (const [, n] of [
      ...t.internal.fields,
      ...t.internal.fieldArrays
    ])
      if (n.getActive() && (n.getTouched() && (e = !0), n.getDirty() && (s = !0), n.getError() && (r = !0)), e && s && r)
        break;
  }), ut(() => {
    t.internal.setTouched(e), t.internal.setDirty(s), t.internal.setInvalid(r);
  });
}
function Tr(t, e) {
  at(() => {
    var s, r;
    return (r = (s = t.internal.fields.get(e)) == null ? void 0 : s.getElements()[0]) == null ? void 0 : r.focus();
  });
}
function Zt(t, e, s = {}) {
  const { shouldActive: r = !0, shouldTouched: n = !1, shouldDirty: o = !1 } = s, i = t.internal.fieldArrays.has(e) ? Mt(t, e) : Nt(t, e);
  if ((!r || i.getActive()) && (!n || i.getTouched()) && (!o || i.getDirty()))
    return i.getError();
}
function M(t, e, s = {}) {
  const { shouldActive: r = !0, shouldTouched: n = !1, shouldDirty: o = !1, shouldValid: i = !1 } = s, l = Nt(t, e);
  if ((!r || l.getActive()) && (!n || l.getTouched()) && (!o || l.getDirty()) && (!i || !l.getError()))
    return l.getInput();
}
function Rt(t, e, s) {
  const [r] = Ce(t, e), { shouldActive: n = !0, shouldTouched: o = !1, shouldDirty: i = !1, shouldValid: l = !1 } = Ae(e, s);
  return typeof e != "string" && !Array.isArray(e) && t.internal.getFieldNames(), Pr(t, r, {
    initialValue: {},
    shouldActive: n,
    shouldTouched: o,
    shouldDirty: i,
    shouldValid: l
  });
}
async function fn(t, e, s) {
  const [r, n] = Ce(t, e), { shouldActive: o = !0, shouldFocus: i = !0 } = Ae(e, s), l = Lt();
  t.internal.validators.add(l), t.internal.setValidating(!0);
  let a = !0;
  return await ut(async () => {
    await at(async () => {
      const u = t.internal.validate ? await t.internal.validate(Rt(t, { shouldActive: o })) : {}, [d] = await Promise.all([
        // Validate each field in list
        Promise.all(r.map(async (c) => {
          const p = Nt(t, c);
          if (!o || p.getActive()) {
            let f;
            for (const g of p.validate)
              if (f = await g(p.getInput()), f)
                break;
            const w = f || u[c] || "";
            return w && (a = !1), p.setError(w), w ? c : null;
          }
        })),
        // Validate each field array in list
        Promise.all(n.map(async (c) => {
          const p = Mt(t, c);
          if (!o || p.getActive()) {
            let f = "";
            for (const g of p.validate)
              if (f = await g(p.getItems()), f)
                break;
            const w = f || u[c] || "";
            w && (a = !1), p.setError(w);
          }
        }))
      ]);
      if (i) {
        const c = d.find((p) => p);
        c && Tr(t, c);
      }
      t.internal.setInvalid([...t.internal.fields, ...t.internal.fieldArrays].some(([, c]) => c.getActive() && c.getError())), t.internal.validators.delete(l), t.internal.validators.size || t.internal.setValidating(!1);
    });
  }), a;
}
function Fr(t, e, s = {}) {
  return async (r) => {
    r.preventDefault();
    const { keepResponse: n = !1, shouldActive: o = !0, shouldTouched: i = !1, shouldDirty: l = !1, shouldFocus: a = !0 } = s;
    ut(() => {
      n || t.internal.setResponse({}), t.internal.setSubmitCount((u) => u + 1), t.internal.setSubmitted(!0), t.internal.setSubmitting(!0);
    });
    try {
      await fn(t, { shouldActive: o, shouldFocus: a }) && await e(Rt(t, {
        shouldActive: o,
        shouldTouched: i,
        shouldDirty: l
      }), r);
    } catch (u) {
      t.internal.setResponse({
        status: "error",
        message: (u == null ? void 0 : u.message) || "An unknown error has occurred."
      });
    } finally {
      t.internal.setSubmitting(!1);
    }
  };
}
function ve(t, e, s) {
  ut(() => {
    at(() => {
      const { at: r, value: n } = s, o = Mt(t, e), i = o.getItems().length - 1;
      if (r >= 0 && r <= i) {
        const l = (a) => a.startsWith(`${e}.`) && _e(e, a) === r;
        t.internal.getFieldNames().filter(l).forEach((a) => {
          const u = le(a.replace(new RegExp(`${e}.${_e(e, a)}.?`), ""), n);
          Cr(Nt(t, a), {
            elements: [],
            initialInput: u,
            input: u,
            error: "",
            dirty: !1,
            touched: !1
          });
        }), t.internal.getFieldArrayNames().filter(l).forEach((a) => {
          const u = (le(a.replace(new RegExp(`${e}.${_e(e, a)}.?`), ""), n) || []).map(() => Lt());
          Nr(Mt(t, a), {
            initialItems: u,
            items: u,
            error: "",
            dirty: !1,
            touched: !1
          });
        }), o.setItems((a) => {
          const u = [...a];
          return u[r] = Lt(), u;
        }), o.setTouched(!0), t.internal.setTouched(!0), o.setDirty(!0), t.internal.setDirty(!0);
      }
    });
  });
}
function st(t, e, s) {
  let [r, n] = Ce(t, e);
  const o = typeof e == "string" && r.length === 1, i = !o && !Array.isArray(e), { initialValue: l, initialValues: a, keepResponse: u = !1, keepSubmitCount: d = !1, keepSubmitted: c = !1, keepValues: p = !1, keepDirtyValues: f = !1, keepItems: w = !1, keepDirtyItems: g = !1, keepErrors: v = !1, keepTouched: k = !1, keepDirty: I = !1 } = Ae(e, s);
  o ? l && mn(t, r[0], l[0]) : a && (i ? t.internal.initialValues = a : t.internal.initialValues = {
    ...t.internal.initialValues,
    ...a
  }), ut(() => {
    r.forEach((P) => {
      const $ = Nt(t, P), S = dn(t, P);
      $.setInitialInput(() => S);
      const j = f && $.getDirty();
      !p && !j && ($.setInput(() => S), $.getElements().forEach((H) => {
        H.type === "file" && (H.value = "");
      })), k || $.setTouched(!1), !I && !p && !j && $.setDirty(!1), v || $.setError("");
    }), n.forEach((P) => {
      const $ = Mt(t, P), S = g && $.getDirty();
      if (!w && !S) {
        const j = pn(t, P);
        $.setInitialItems(j), $.setItems(j);
      }
      k || $.setTouched(!1), !I && !w && !S && $.setDirty(!1), v || $.setError("");
    }), i && (u || t.internal.setResponse({}), d || t.internal.setSubmitCount(0), c || t.internal.setSubmitted(!1)), ke(t);
  });
}
function E(t, e, s, r = {}) {
  const { shouldTouched: n = !0, shouldDirty: o = !0, shouldValidate: i = !0, shouldFocus: l = !0 } = r;
  at(() => {
    const a = Nt(t, e);
    ut(() => {
      a.setInput(() => s), n && (a.setTouched(!0), t.internal.setTouched(!0)), o && Te(t, a), i && ce(t, a, e, {
        on: ["touched", "input"],
        shouldFocus: l
      });
    });
  });
}
function Er(t, e, s = {}) {
  const { initialValue: r, keepActive: n = !1, keepState: o = !0 } = s, i = gn(s.validate);
  let l;
  const a = Lt();
  return ut(() => {
    l = Nt(t, e, { initialValue: r, validate: i }), l.consumers.add(a), r && (mn(t, e, r[0]), l.setInitialInput(() => r[0]), Te(t, l)), at(l.getActive) || (l.setActive(!0), ke(t));
  }), Yt(() => {
    l.consumers.delete(a), !n && !l.consumers.size && ut(() => {
      l.setActive(!1), o ? ke(t) : st(t, e);
    }), setTimeout(() => l.setElements((u) => u.filter((d) => d.isConnected)));
  }), {
    props: {
      name: e,
      ref(u) {
        ut(() => {
          l.setElements((d) => [...d, u]), Ht(() => {
            if (l.getInitialInput() === void 0 && at(l.getInput) === void 0 && u.type !== "radio" && u.type !== "file") {
              const d = Ve(u, l);
              l.setInitialInput(() => d), l.setInput(() => d);
            }
          });
        });
      },
      onInput(u) {
        je(t, l, e, Ve(u.currentTarget, l));
      },
      onChange() {
        ce(t, l, e, { on: ["change"] });
      },
      onBlur(u) {
        ut(() => {
          const { type: d, value: c } = u.currentTarget;
          d === "number" && c === "" ? je(t, l, e, NaN) : (l.setTouched(!0), t.internal.setTouched(!0)), ce(t, l, e, { on: ["touched", "blur"] });
        });
      }
    },
    name: e,
    get value() {
      return l.getInput();
    },
    get error() {
      return l.getError();
    },
    get active() {
      return l.getActive();
    },
    get touched() {
      return l.getTouched();
    },
    get dirty() {
      return l.getDirty();
    }
  };
}
function Vr(t, e, s = {}) {
  const { keepActive: r = !1, keepState: n = !0 } = s, o = gn(s.validate), i = Mt(t, e, { validate: o }), l = Lt();
  return i.consumers.add(l), i.setActive(!0), Yt(() => {
    i.consumers.delete(l), !r && !i.consumers.size && ut(() => {
      i.setActive(!1), n || st(t, e);
    });
  }), {
    name: e,
    get items() {
      return i.getItems();
    },
    get length() {
      return i.getItems().length;
    },
    get error() {
      return i.getError();
    },
    get active() {
      return i.getActive();
    },
    get touched() {
      return i.getTouched();
    },
    get dirty() {
      return i.getDirty();
    }
  };
}
function ft(t) {
  const [e, s] = Pe(t, ["of", "name", "children"]);
  return V(() => e.children(Er(e.of, e.name, s)));
}
function jr(t) {
  const [e, s] = Pe(t, ["of", "name", "children"]);
  return V(() => e.children(Vr(e.of, e.name, s)));
}
const Dr = /* @__PURE__ */ y("<form></form>");
function Ct(t) {
  const [e, s, r] = Pe(t, ["of", "onSubmit", "children"], ["keepResponse", "shouldActive", "shouldTouched", "shouldDirty", "shouldFocus"]);
  return (() => {
    const n = Dr.cloneNode(!0), o = t.of.internal.setElement;
    return typeof o == "function" ? Je(o, n) : t.of.internal.setElement = n, ct(n, mt(r, {
      get onSubmit() {
        return Fr(e.of, e.onSubmit, s);
      },
      noValidate: ""
    }), !1, !0), h(n, () => e.children), n;
  })();
}
const [Rr, At] = O("");
let re;
const Lr = new Uint8Array(16);
function Mr() {
  if (!re && (re = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !re))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return re(Lr);
}
const ot = [];
for (let t = 0; t < 256; ++t)
  ot.push((t + 256).toString(16).slice(1));
function Br(t, e = 0) {
  return (ot[t[e + 0]] + ot[t[e + 1]] + ot[t[e + 2]] + ot[t[e + 3]] + "-" + ot[t[e + 4]] + ot[t[e + 5]] + "-" + ot[t[e + 6]] + ot[t[e + 7]] + "-" + ot[t[e + 8]] + ot[t[e + 9]] + "-" + ot[t[e + 10]] + ot[t[e + 11]] + ot[t[e + 12]] + ot[t[e + 13]] + ot[t[e + 14]] + ot[t[e + 15]]).toLowerCase();
}
const Or = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), De = {
  randomUUID: Or
};
function Tt(t, e, s) {
  if (De.randomUUID && !e && !t)
    return De.randomUUID();
  t = t || {};
  const r = t.random || (t.rng || Mr)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, e) {
    s = s || 0;
    for (let n = 0; n < 16; ++n)
      e[s + n] = r[n];
    return e;
  }
  return Br(r);
}
const Hr = (t) => {
  const e = /* @__PURE__ */ new Map(), s = (r, n) => {
    typeof r == "object" && r !== null ? Object.keys(r).forEach((o) => {
      s(r[o], n ? `${n}.${o}` : o);
    }) : e.set(n, r);
  };
  return s(t, ""), e;
}, wn = (t, e) => {
  [
    ...Hr(e ?? t.internal.initialValues).keys()
  ].forEach((s) => {
    M(t, s);
  });
}, [Wr, Ie] = O([]), gt = _.object({
  personalizationId: _.string().uuid().optional(),
  productIds: _.array(_.string()).optional()
}), qr = gt.extend({
  productIds: _.array(_.string()).optional()
}), Ur = gt.extend({
  productId: _.string().optional()
});
gt.extend({
  productIds: _.array(_.string())
});
gt.extend({
  productIds: _.array(_.string())
});
const hn = gt.extend({
  textContent: _.string(),
  fontFamily: _.string(),
  productIds: _.array(_.string()).optional()
}), Kr = gt.extend({
  color: _.string().min(1),
  font: _.string().min(1),
  letters: _.array(_.string().min(1)).min(1).max(3)
}), Jr = _.object({
  customizationProductId: _.string().uuid(),
  monogram: gt,
  giftWrap: gt,
  engraving: hn.or(
    gt.extend({
      textContent: _.undefined(),
      fontFamily: _.undefined(),
      productIds: _.undefined()
    })
  ),
  singleStickers: gt,
  bundleStickers: gt,
  tags: Kr.or(
    gt.extend({
      color: _.undefined(),
      font: _.undefined(),
      letters: _.undefined()
    })
  )
}), Gr = Tt(), bn = () => ({
  monogram: {
    personalizationId: Tt()
  },
  giftWrap: {
    personalizationId: Tt()
  },
  engraving: {
    personalizationId: Tt()
  },
  bundleStickers: {
    personalizationId: Tt()
  },
  singleStickers: {
    personalizationId: Tt()
  },
  tags: {
    personalizationId: Tt()
  }
}), C = Pt({
  initialValues: {
    customizationProductId: Gr,
    ...bn()
  },
  validate: St(Jr)
});
wn(C);
const Et = (t, e) => {
  const s = window.Shopify.country, r = window.Shopify.locale, n = window.Shopify.currency.active;
  return Intl.NumberFormat(`${r}-${s}`, {
    style: "currency",
    currency: n,
    currencyDisplay: "code",
    ...e
  }).format(t);
}, kt = (t) => t.split("/").at(-1), Zr = /* @__PURE__ */ y('<ul class="!tw-block"></ul>'), Xr = /* @__PURE__ */ y('<div><div class="tw-flex tw-flex-col tw-gap-2"><button class="tw-button tw-button-primary" type="submit"></button><button class="tw-button tw-button-secondary"></button></div></div>'), Qr = /* @__PURE__ */ y('<nav class="tw-flex tw-h-full tw-flex-col tw-justify-between"></nav>'), Yr = /* @__PURE__ */ y('<div class="tw-mb-2 tw-flex tw-gap-5"><button type="button" class="tw-flex tw-items-center tw-gap-2"><span class="tw-typ-body-3 tw-border-b tw-border-black"></span></button><button type="button" class="tw-flex tw-items-center tw-gap-2"><span class="tw-typ-body-3 tw-border-b tw-border-black"></span></button></div>'), ts = /* @__PURE__ */ y('<li class="tw-typ-h4-subtopic-2 tw-border-b tw-border-border tw-py-2"><button class="tw-button tw-flex tw-flex-wrap tw-px-0 tw-py-3"><span class="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-between"></span><span class="tw-typ-body-2 tw-w-full tw-text-start"></span></button></li>'), Re = /* @__PURE__ */ y('<li class="tw-typ-h5-subtopic-3-b tw-flex tw-justify-between tw-py-1"><span></span><span></span></li>'), es = /* @__PURE__ */ y('<li class="tw-typ-h5-subtopic-3-b tw-flex tw-justify-between tw-border-t tw-border-black tw-py-4"><span>Subtotal</span> <span></span></li>'), ns = /* @__PURE__ */ y('<ul class="tw-mt-5"></ul>'), rs = {
  monogram: "monograms",
  engraving: "engraving",
  giftWrap: "gift-wrap",
  bundleStickers: "stickers",
  singleStickers: "stickers",
  tags: "tags"
}, ss = {
  monogram: window.customizationProduct.translations.tittles["monogram-tittle"],
  engraving: window.customizationProduct.translations.tittles["engraving-title"],
  bundleStickers: window.customizationProduct.translations.customization["customization-stickers-bundle-title"],
  singleStickers: window.customizationProduct.translations.customization["customization-stickers-single-title"],
  tags: window.customizationProduct.translations.tittles["tag-title"],
  giftWrap: window.customizationProduct.translations.tittles["gif-title"]
}, Ft = () => Rt(C, {
  shouldActive: !1
}), os = () => {
  const {
    customizationProductId: t,
    ...e
  } = Ft();
  return e;
}, is = (t, e) => {
  const s = t.map((n) => {
    var i, l;
    const o = (l = (i = Xe()[e]) == null ? void 0 : i.collection) == null ? void 0 : l.products.nodes.find((a) => kt(a.variants.nodes[0].id) === String(n));
    return {
      price: o == null ? void 0 : o.variants.nodes[0].price
    };
  }), r = s == null ? void 0 : s.reduce((n, o) => {
    var i;
    return n + parseFloat((i = o == null ? void 0 : o.price) == null ? void 0 : i.amount);
  }, 0);
  return {
    items: s,
    totalAmount: r
  };
}, se = () => {
  const t = Object.entries(os()).map(([s, r]) => ({
    ...is((r == null ? void 0 : r.productIds) || [], rs[s]),
    customization: s
  })), e = t == null ? void 0 : t.reduce((s, r) => s + (r == null ? void 0 : r.totalAmount), 0);
  return {
    items: t,
    total: e,
    available: t.find((s) => s.items.length > 0)
  };
}, as = (t) => {
  At(window.customizationProduct.translations.customization["customization-title"]);
  const e = (s) => {
    const r = On();
    if (!r)
      return null;
    const n = s.path.replace("/", ""), o = t.routesTitle[s.path], i = r.includes(n), l = window.customizationProduct.availableCustomizations[n];
    return {
      title: o,
      isAvailable: i && l,
      key: n
    };
  };
  return (() => {
    const s = Qr.cloneNode(!0);
    return h(s, b(K, {
      get when() {
        return Dt();
      },
      get children() {
        return [(() => {
          const r = Zr.cloneNode(!0);
          return h(r, b(it, {
            get each() {
              return t.rootLevelRoutesPaths;
            },
            children: (n) => b(K, {
              get when() {
                return e(n);
              },
              keyed: !0,
              children: ({
                isAvailable: o,
                key: i,
                title: l
              }) => b(K, {
                when: o,
                get children() {
                  return b(ls, {
                    get path() {
                      return n.path;
                    },
                    title: l,
                    key: i
                  });
                }
              })
            })
          })), r;
        })(), (() => {
          const r = Xr.cloneNode(!0), n = r.firstChild, o = n.firstChild, i = o.nextSibling;
          return h(r, b(cs, {}), n), h(o, () => window.customizationProduct.translations.buttons["customization-button-add-to-cart"]), i.$$click = () => ae("close"), h(i, () => window.customizationProduct.translations.buttons["customization-cancel-button"]), D((l) => {
            const a = C.submitting || C.submitted, u = C.submitting;
            return a !== l._v$ && (o.disabled = l._v$ = a), u !== l._v$2 && (i.disabled = l._v$2 = u), l;
          }, {
            _v$: void 0,
            _v$2: void 0
          }), r;
        })()];
      }
    })), s;
  })();
}, ls = (t) => {
  const e = dt(), s = () => Xe()[t.key], r = V(() => {
    var i, l;
    return (l = (i = s()) == null ? void 0 : i.collection) == null ? void 0 : l.products.nodes.reduce((a, u) => {
      const d = u.variants.nodes[0].price.amount;
      return {
        min: d > 0 && d < a.min ? d : a.min,
        max: d > 0 && d > a.max ? d : a.max
      };
    }, {
      min: 0,
      max: 0
    });
  }), n = (i) => {
    var l, a, u, d, c, p, f, w, g;
    switch (i) {
      case "monograms":
        return [...((l = Ft().monogram) == null ? void 0 : l.productIds) || []];
      case "engraving":
        return [...((a = Ft().engraving) == null ? void 0 : a.productIds) || []];
      case "stickers":
        return [...((d = (u = Ft()) == null ? void 0 : u.bundleStickers) == null ? void 0 : d.productIds) || [], ...((p = (c = Ft()) == null ? void 0 : c.singleStickers) == null ? void 0 : p.productIds) || []];
      case "tags":
        return [...((w = (f = Ft()) == null ? void 0 : f.tags) == null ? void 0 : w.productIds) || []];
      case "gift-wrap":
        return [...((g = Ft().giftWrap) == null ? void 0 : g.productIds) || []];
      default:
        return [];
    }
  }, o = (i) => {
    switch (i) {
      case "monograms":
        st(C, "monogram.productIds"), E(C, "monogram.productIds", void 0);
        return;
      case "engraving":
        st(C, ["engraving.productIds", "engraving.fontFamily", "engraving.textContent"]), E(C, "engraving.productIds", void 0), E(C, "engraving.fontFamily", void 0), E(C, "engraving.textContent", void 0);
        return;
      case "stickers":
        st(C, ["bundleStickers.productIds", "singleStickers.productIds"]), E(C, "bundleStickers.productIds", void 0), E(C, "singleStickers.productIds", void 0);
        return;
      case "tags":
        st(C, ["tags.color", "tags.font", "tags.letters", "tags.productIds"]), E(C, "tags.color", void 0), E(C, "tags.font", void 0), E(C, "tags.letters", void 0), E(C, "tags.productIds", void 0);
        return;
      case "gift-wrap":
        st(C, "giftWrap.productIds"), E(C, "giftWrap.productIds", void 0);
        return;
    }
  };
  return b(K, {
    get when() {
      return s();
    },
    keyed: !0,
    children: (i) => b(K, {
      get when() {
        return V(() => !!qn(i))() && Un(i);
      },
      keyed: !0,
      get children() {
        const l = ts.cloneNode(!0), a = l.firstChild, u = a.firstChild, d = u.nextSibling;
        return a.$$click = () => e(t.path, {
          state: "home"
        }), h(u, () => t.title, null), h(u, b(Ye, {
          class: "tw-inline-block tw-h-4 tw-w-4"
        }), null), h(d, b(K, {
          get when() {
            return r();
          },
          keyed: !0,
          children: (c) => [V(() => Et(c.min)), V((() => {
            const p = V(() => c.max > 0);
            return () => p() && ` - ${Et(c.max)}`;
          })())]
        })), h(l, b(K, {
          get when() {
            return n(t.key).length > 0;
          },
          keyed: !0,
          get children() {
            const c = Yr.cloneNode(!0), p = c.firstChild, f = p.firstChild, w = p.nextSibling, g = w.firstChild;
            return p.$$click = () => e(t.path, {
              state: "home"
            }), h(p, b(kr, {
              class: "tw-w-5"
            }), f), h(f, () => window.customizationProduct.translations.buttons["button-edit"]), w.$$click = () => o(t.key), h(w, b(zr, {
              class: "tw-w-5"
            }), g), h(g, () => window.customizationProduct.translations.buttons["button-delete"]), c;
          }
        }), null), l;
      }
    })
  });
}, cs = () => (() => {
  const t = ns.cloneNode(!0);
  return h(t, b(K, {
    get when() {
      return se().available;
    },
    get children() {
      const e = Re.cloneNode(!0), s = e.firstChild, r = s.nextSibling;
      return h(s, () => {
        var n, o;
        return (o = (n = Dt()) == null ? void 0 : n.product) == null ? void 0 : o.title;
      }), h(r, () => {
        var n, o;
        return Et((o = (n = Dt()) == null ? void 0 : n.product) == null ? void 0 : o.variants.nodes[0].price.amount);
      }), e;
    }
  }), null), h(t, b(it, {
    get each() {
      return se().items;
    },
    children: (e) => b(K, {
      get when() {
        return e.items.length > 0;
      },
      get children() {
        const s = Re.cloneNode(!0), r = s.firstChild, n = r.nextSibling;
        return h(r, () => ss[e.customization]), h(n, () => Et(e.totalAmount)), s;
      }
    })
  }), null), h(t, b(K, {
    get when() {
      return se().available;
    },
    get children() {
      const e = es.cloneNode(!0), s = e.firstChild, r = s.nextSibling, n = r.nextSibling;
      return h(n, () => {
        var o, i;
        return Et(Number(se().total) + Number((i = (o = Dt()) == null ? void 0 : o.product) == null ? void 0 : i.variants.nodes[0].price.amount));
      }), e;
    }
  }), null), t;
})();
yt(["click"]);
const us = /* @__PURE__ */ y('<label class="tw-button tw-button-secondary tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-border tw-border-border peer-checked:tw-border-primary"></label>'), Xt = (t) => (() => {
  const e = us.cloneNode(!0);
  return ct(e, t, !1, !1), e;
})(), ds = /* @__PURE__ */ y('<div class="tw-w-full"></div>'), ps = /* @__PURE__ */ y('<div class="tw-flex-col tw-gap-y-10"><div class="tw-flex tw-flex-col tw-justify-center tw-gap-9"><div><h1 class="tw-typ-h5-subtopic-3-a"></h1><p class="tw-typ-body-2 tw-text-secondary"></p></div><div class="tw-flex tw-flex-col tw-gap-7"><div class="tw-flex tw-h-20 tw-gap-6"></div><p class="tw-typ-body-2 tw-text-secondary"></p></div></div></div>'), gs = /* @__PURE__ */ y('<div class="tw-flex tw-flex-col tw-justify-between tw-gap-2"><button class="tw-button tw-button-primary" type="submit"></button><button class="tw-button tw-button-secondary"></button></div>'), ms = /* @__PURE__ */ y('<input type="radio" class="tw-peer tw-hidden" id="standard-id" value="off">'), fs = /* @__PURE__ */ y('<input type="radio" class="tw-peer tw-hidden" id="gift-id">'), ws = Ur.pick({
  productId: !0
}), Le = (t) => (() => {
  const e = ds.cloneNode(!0);
  return ct(e, t, !1, !1), e;
})(), qt = Pt({
  validate: St(ws),
  validateOn: "input"
}), hs = () => {
  At(window.customizationProduct.translations.tittles["gif-title"]);
  const t = dt();
  de(() => {
    const r = M(C, "giftWrap.productIds", {
      shouldActive: !1
    });
    st(qt, {
      initialValues: {
        productId: r != null && r.length ? `gid://shopify/ProductVariant/${r[0]}` : "off"
      }
    });
  });
  const [e] = zt();
  return b(Ct, {
    of: qt,
    class: "tw-flex tw-h-full tw-flex-col tw-justify-between",
    onSubmit: (r, n) => {
      var l;
      if (((l = n.submitter) == null ? void 0 : l.getAttribute("type")) !== "submit") {
        C.internal.setSubmitted(!1);
        return;
      }
      if (!r.productId)
        return;
      const i = kt(r.productId);
      r.productId === "off" ? st(C, "giftWrap.productIds") : E(C, "giftWrap.productIds", [i], {
        shouldValidate: !1
      }), t("/");
    },
    get children() {
      return [(() => {
        const r = ps.cloneNode(!0), n = r.firstChild, o = n.firstChild, i = o.firstChild, l = i.nextSibling, a = o.nextSibling, u = a.firstChild, d = u.nextSibling;
        return h(i, () => window.customizationProduct.translations.gifs["customization-gif-item-1-text-1"]), h(l, () => window.customizationProduct.translations.gifs["customization-gif-item-1-text-2"]), h(u, b(ft, {
          of: qt,
          name: "productId",
          keepState: !0,
          children: (c) => [b(Le, {
            get children() {
              return [(() => {
                const p = ms.cloneNode(!0);
                return xe(p, "input", c.props.onInput, !0), D(() => G(p, "name", c.props.name)), D(() => p.checked = c.value === "off" || !c.value), p;
              })(), b(Xt, {
                for: "standard-id",
                get children() {
                  return window.customizationProduct.translations.gifs["customization-gif-item-1-text-3"];
                }
              })];
            }
          }), b(Le, {
            get children() {
              return [(() => {
                const p = fs.cloneNode(!0);
                return xe(p, "input", c.props.onInput, !0), D(() => G(p, "name", c.props.name)), D(() => {
                  var f, w, g, v, k, I, P, $;
                  return p.value = ($ = (P = (I = (k = (v = (g = (w = (f = e()) == null ? void 0 : f.collection) == null ? void 0 : w.products) == null ? void 0 : g.nodes) == null ? void 0 : v[0]) == null ? void 0 : k.variants) == null ? void 0 : I.nodes) == null ? void 0 : P[0]) == null ? void 0 : $.id;
                }), D(() => {
                  var f, w, g, v, k, I, P, $;
                  return p.checked = c.value === (($ = (P = (I = (k = (v = (g = (w = (f = e()) == null ? void 0 : f.collection) == null ? void 0 : w.products) == null ? void 0 : g.nodes) == null ? void 0 : v[0]) == null ? void 0 : k.variants) == null ? void 0 : I.nodes) == null ? void 0 : P[0]) == null ? void 0 : $.id);
                }), p;
              })(), b(Xt, {
                for: "gift-id",
                get children() {
                  var p, f, w, g, v;
                  return (v = (g = (w = (f = (p = e()) == null ? void 0 : p.collection) == null ? void 0 : f.products) == null ? void 0 : w.nodes) == null ? void 0 : g[0]) == null ? void 0 : v.title;
                }
              })];
            }
          })]
        })), h(d, () => window.customizationProduct.translations.gifs["customization-gif-item-1-text-5"]), r;
      })(), (() => {
        const r = gs.cloneNode(!0), n = r.firstChild, o = n.nextSibling;
        return h(n, () => window.customizationProduct.translations.buttons["customization-apply-button"]), o.$$click = () => t("/"), h(o, () => window.customizationProduct.translations.buttons["customization-button-cancel"]), D(() => n.disabled = qt.invalid || !qt.dirty), r;
      })()];
    }
  });
};
yt(["click", "input"]);
const bs = /* @__PURE__ */ y('<div class="tw-relative tw-flex"><input type="radio"><span class="tw-absolute tw-inset-0 tw-hidden  tw-cursor-not-allowed tw-rounded-full tw-bg-box-background tw-opacity-50 peer-disabled:tw-block"><div class="tw-relative tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-p-2"><span class="tw-z-10 tw-block tw-h-full tw-w-[2px] -tw-rotate-45 tw-bg-primary"></span></div></span><label class="tw-block tw-h-10 tw-w-10 tw-cursor-pointer tw-rounded-full tw-transition-[padding,border-color] peer-checked:tw-border peer-checked:tw-border-border peer-checked:tw-p-1"><img class="tw-h-full tw-w-full tw-rounded-full"></label></div>'), _n = (t) => (() => {
  const e = bs.cloneNode(!0), s = e.firstChild, r = s.nextSibling, n = r.nextSibling, o = n.firstChild;
  return ct(s, mt(() => t.inputProps), !1, !1), ct(o, mt(() => t.imgProps), !1, !1), D(() => G(n, "for", t.inputProps.id)), e;
})(), _s = /* @__PURE__ */ y('<div class="tw-flex tw-justify-center"><figure class="tw-relative tw-h-[330px] tw-w-[270]"></figure></div>'), vs = /* @__PURE__ */ y('<img alt="background" class="tw-h-full tw-w-full tw-object-contain">'), ys = /* @__PURE__ */ y('<figcaption><div class="tw-relative tw-h-full tw-w-full"></div></figcaption>'), ye = {
  "center-left": "tw-top-[23%] tw-left-[1%]",
  "center-center": "tw-top-[50%] tw-left-[50%] tw-transform tw--translate-x-1/2 tw--translate-y-1/2",
  "stickers-center-center": "tw-top-[25%] tw-left-[17%]",
  "top-left": "tw-top-[5%] tw-left-[11%]"
}, Bt = (t) => {
  const e = Se(() => t.children);
  return (() => {
    const s = _s.cloneNode(!0), r = s.firstChild;
    return h(r, b(K, {
      keyed: !0,
      get when() {
        return t.background;
      },
      children: (n) => [(() => {
        const o = vs.cloneNode(!0);
        return G(o, "src", n), o;
      })(), (() => {
        const o = ys.cloneNode(!0), i = o.firstChild;
        return h(i, e), D(() => Ge(o, `tw-absolute tw-flex tw-h-[165px] tw-w-[162px] tw-justify-center ${t.location && (ye == null ? void 0 : ye[t.location])}`)), o;
      })()]
    })), s;
  })();
}, Ot = (t) => {
  var s;
  const e = (s = t == null ? void 0 : t.collection) == null ? void 0 : s.products.nodes.reduce(
    (r, n) => {
      const o = n.variants.nodes[0].price.amount;
      return {
        min: o > 0 && o < r.min ? o : r.min,
        max: o > 0 && o > r.max ? o : r.max
      };
    },
    {
      min: 0,
      max: 0
    }
  );
  return ` ${Et((e == null ? void 0 : e.min) || 0)} ${Number(e == null ? void 0 : e.max) > 0 ? ` - ${Et((e == null ? void 0 : e.max) || 0)}` : ""}`;
}, $s = /* @__PURE__ */ y('<div class="tw-flex tw-items-center tw-gap-2 tw-py-2"></div>'), xs = /* @__PURE__ */ y('<p class="tw-typ-body-2 tw-text-secondary"></p>'), ks = /* @__PURE__ */ y('<div class="tw-custom-scrollbar tw-flex tw-flex-auto tw-flex-nowrap tw-gap-6 tw-overflow-auto tw-py-2"></div>'), Is = /* @__PURE__ */ y('<p class="tw-typ-body-3 tw-text-error"></p>'), zs = /* @__PURE__ */ y('<div class="tw-relative tw-inline tw-h-[100px] tw-flex-shrink-0"><input type="checkbox" class="tw-peer !tw-hidden"><span class="tw-absolute tw-inset-0 tw-hidden tw-cursor-not-allowed tw-bg-background tw-bg-opacity-75 peer-disabled:tw-block"></span><label class="tw-block tw-h-full tw-w-full tw-select-none tw-border tw-border-transparent peer-checked:tw-border-primary peer-disabled:tw-cursor-not-allowed"><img class="tw-h-full tw-w-full tw-object-contain tw-px-2"></label></div>'), Ss = /* @__PURE__ */ y("<div>Error getting product data...</div>"), Ps = /* @__PURE__ */ y('<div class="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center"></div>'), Ns = /* @__PURE__ */ y('<button class="tw-button tw-button-primary"></button>'), Cs = /* @__PURE__ */ y('<div class="tw-flex tw-h-full tw-flex-col tw-justify-between tw-gap-y-10"><div><div class="tw-flex tw-justify-center"></div><div class="tw-flex tw-flex-col tw-gap-5"><div><p class="tw-typ-body-2 tw-text-secondary"> <!> </p><p class="tw-typ-h5-subtopic-3-a"></p><p class="tw-typ-body-2 tw-text-secondary"></p></div></div></div><div class="tw-flex tw-flex-col tw-gap-4"><button class="tw-button tw-button-secondary"></button></div></div>'), As = /* @__PURE__ */ y('<img class="tw-h-11 tw-w-11 tw-object-contain tw-px-2">'), Ts = /* @__PURE__ */ y('<button class="tw-button tw-button-secondary"></button>'), Fs = /* @__PURE__ */ y('<button class="tw-button tw-button-primary" type="submit"></button>'), Es = _.object({
  assets: _.array(_.object({
    id: _.number(),
    uri_internal: _.string().nullable(),
    asset_source: _.string().nullable(),
    size: _.number().nullable(),
    name: _.string().nullable(),
    tags: _.string().nullable()
  })),
  category_attributes: _.array(_.object({
    id: _.number().nullable(),
    name: _.string().optional().nullable(),
    slug: _.string().nullable(),
    displayName: _.string().optional().nullable(),
    value: _.string()
  }))
}).deepPartial(), [Qt, Me] = O(null), Vs = qr.pick({
  productIds: !0
}), pt = Pt({
  validate: St(Vs),
  validateOn: "input"
}), js = (t) => {
  const [e] = zt(), s = V(() => {
    var i, l;
    const n = e();
    if (e.error || e.loading && !n)
      return null;
    const o = Es.safeParse(JSON.parse(((l = (i = n == null ? void 0 : n.collection) == null ? void 0 : i.metafield) == null ? void 0 : l.value) || "{}"));
    return o.success ? o.data : null;
  }), r = V(() => {
    var o, i, l;
    const n = (l = (i = (o = s()) == null ? void 0 : o.category_attributes) == null ? void 0 : i.find((a) => a.slug === "available-colors")) == null ? void 0 : l.value;
    try {
      return Qe.parse(JSON.parse(n || "[]")).map((a) => {
        var u, d;
        return {
          asset: (d = (u = s()) == null ? void 0 : u.assets) == null ? void 0 : d.find((c) => {
            var p;
            return (p = c.tags) == null ? void 0 : p.split(",").some((f) => f === `color-image-thumbnail:${a.value}`);
          }),
          ...a
        };
      }).filter(Boolean);
    } catch (a) {
      return console.error("Error parsing available colors", a), null;
    }
  });
  return Ht(() => {
    const n = r();
    !n || !(n.length > 0) || Qt() || Me({
      name: n[0].name,
      value: n[0].value
    });
  }), [(() => {
    const n = $s.cloneNode(!0);
    return h(n, b(it, {
      get each() {
        return r();
      },
      get fallback() {
        return b(pe, {});
      },
      children: (o, i) => o ? b(_n, {
        get inputProps() {
          var l, a, u, d;
          return {
            type: "radio",
            class: "tw-peer tw-hidden",
            name: "customization_drawer_monogram_color_selector",
            disabled: !((l = t.productsByColor[o.value]) != null && l.available),
            checked: ((a = Qt()) == null ? void 0 : a.value) === o.value,
            id: `customization_drawer_monogram_color-id-${((u = o.asset) == null ? void 0 : u.id) || ((d = o.asset) == null ? void 0 : d.uri_internal)}`,
            onInput: (c) => {
              st(pt), c.currentTarget.checked && Me({
                name: o.name,
                value: o.value
              });
            }
          };
        },
        get imgProps() {
          var l;
          return {
            src: ((l = o.asset) == null ? void 0 : l.uri_internal) || ""
          };
        }
      }) : null
    })), n;
  })(), (() => {
    const n = xs.cloneNode(!0);
    return h(n, () => window.customizationProduct.translations.monograms["monogram-paragraph-item-2"]), n;
  })()];
}, Ds = (t) => {
  const e = () => Gt(_.array(_.string()).max(t.max, window.customizationProduct.translations.monograms["monogram-error-maximum"].replace("__value__", t.max.toString())).min(t.min, window.customizationProduct.translations.monograms["monogram-error-minimum"].replace("__value__", t.min.toString())));
  return Ht(() => {
    const s = M(pt, "productIds");
    s && (s == null ? void 0 : s.length) > t.max && E(pt, "productIds", s.slice(1));
  }), [(() => {
    const s = ks.cloneNode(!0);
    return h(s, b(it, {
      get each() {
        return t.products;
      },
      children: (r) => b(ft, {
        of: pt,
        name: "productIds",
        get validate() {
          return e();
        },
        children: (n) => (() => {
          const o = zs.cloneNode(!0), i = o.firstChild, l = i.nextSibling, a = l.nextSibling, u = a.firstChild;
          return ct(i, mt({
            get id() {
              return `monogram_product_select_${r.variants.nodes[0].id}`;
            },
            get value() {
              return r.variants.nodes[0].id;
            },
            get checked() {
              var d;
              return (d = n.value) == null ? void 0 : d.includes(r.variants.nodes[0].id);
            }
          }, () => n.props, {
            get disabled() {
              return !r.variants.nodes[0].availableForSale;
            }
          }), !1, !1), D((d) => {
            var f;
            const c = `monogram_product_select_${r.variants.nodes[0].id}`, p = ((f = r.featuredImage) == null ? void 0 : f.url) || "";
            return c !== d._v$ && G(a, "for", d._v$ = c), p !== d._v$2 && G(u, "src", d._v$2 = p), d;
          }, {
            _v$: void 0,
            _v$2: void 0
          }), o;
        })()
      })
    })), s;
  })(), (() => {
    const s = Is.cloneNode(!0);
    return h(s, () => Zt(pt, "productIds", {
      shouldTouched: !0
    })), s;
  })()];
}, $e = [{
  title: window.customizationProduct.translations.monograms["monogram-sub-tittle-item-2"],
  subtitle: (t) => {
    var e;
    return ((e = Qt()) == null ? void 0 : e.name) || window.customizationProduct.translations.monograms["monogram-sub-tittle-item-2"];
  },
  index: 0
}, {
  title: window.customizationProduct.translations.monograms["monogram-sub-tittle-item-1"],
  subtitle: (t) => window.customizationProduct.translations.monograms["monogram-paragraph-item-1"].replace("__value__", t),
  index: 1
}], Rs = (t) => t.endsWith("/") ? t.slice(0, -1) : t, Ls = () => {
  At(window.customizationProduct.translations.customization["customization-monogram-tittle"]), de(() => {
    var g;
    E(pt, "productIds", ((g = M(C, "monogram.productIds", {
      shouldActive: !1
    })) == null ? void 0 : g.map((v) => `gid://shopify/ProductVariant/${v}`)) || [], {
      shouldDirty: !1
    });
  });
  const t = dt(), e = on(), s = ee(), [r] = zt(), n = () => {
    var g, v, k;
    return It(((k = (v = (g = r()) == null ? void 0 : g.collection) == null ? void 0 : v.metafield) == null ? void 0 : k.value) || "", "collection");
  }, o = V(() => {
    var I, P, $, S;
    const g = n();
    if (!g.success)
      return null;
    const v = Number((P = (I = g == null ? void 0 : g.data.category_attributes) == null ? void 0 : I.find((j) => j.slug === "maximum-selection")) == null ? void 0 : P.value), k = Number((S = ($ = g == null ? void 0 : g.data.category_attributes) == null ? void 0 : $.find((j) => j.slug === "minimum-selection")) == null ? void 0 : S.value);
    return {
      max: v,
      min: k
    };
  }), i = V(() => {
    var g, v, k, I;
    return (I = (k = (v = (g = r()) == null ? void 0 : g.collection) == null ? void 0 : v.products) == null ? void 0 : k.nodes) == null ? void 0 : I.reduce((P, $) => {
      var H, X, N, T;
      const S = It((H = $.metafield) == null ? void 0 : H.value, "p_attributes");
      if (!S.success)
        return P;
      const j = (X = S.data) == null ? void 0 : X.find((m) => m.slug === "customization-color-id");
      return j != null && j.value ? {
        ...P,
        [j.value]: {
          available: ((N = P[j.value]) == null ? void 0 : N.available) || $.variants.nodes[0].availableForSale || !1,
          products: [...((T = P[j.value]) == null ? void 0 : T.products) || [], $]
        }
      } : P;
    }, {});
  }), l = V(() => Rs(s.pathname).split("/").slice(0, -1).join("/")), a = V(() => $e[Number(e.id) - 1]), u = () => $e.length === Number(e.id), d = V(() => u() ? "/" : `${l()}/${Number(e.id) + 1}`), c = (g) => {
    if (!g.productIds)
      return;
    const v = g.productIds.map(kt);
    E(C, "monogram.productIds", v, {
      shouldValidate: !1,
      shouldTouched: !0
    }), t("/");
  };
  if (!n().success)
    return Ss.cloneNode(!0);
  const p = () => M(pt, "productIds", {
    shouldActive: !1
  }), f = () => {
    var v, k;
    const g = (v = Qt()) == null ? void 0 : v.value;
    return g ? ((k = p()) == null ? void 0 : k.map((I) => {
      var P, $, S, j, H;
      return (H = (j = (S = ($ = (P = i()) == null ? void 0 : P[g]) == null ? void 0 : $.products) == null ? void 0 : S.find((X) => X.variants.nodes[0].id === I)) == null ? void 0 : j.featuredImage) == null ? void 0 : H.url;
    })) || [] : [];
  }, w = () => {
    var j, H, X, N, T, m, x, z, R, B;
    const g = n(), v = xt.currentProductAttributes(), k = xt.currentProductAssets();
    if (!g.success && !v.success && !k.success)
      return null;
    const I = (g == null ? void 0 : g.success) && ((X = (H = (j = g.data) == null ? void 0 : j.assets) == null ? void 0 : H.find((A) => {
      var L;
      return (L = A.tags) == null ? void 0 : L.split(",").includes("category-base-product-image-with-zoom-default");
    })) == null ? void 0 : X.uri_internal), P = (k == null ? void 0 : k.success) && ((T = (N = k.data) == null ? void 0 : N.find((A) => (A == null ? void 0 : A.type) === "product_base_product_image_with_zoom_monogram")) == null ? void 0 : T.uri_internal), $ = g.success && ((z = (x = (m = g.data) == null ? void 0 : m.category_attributes) == null ? void 0 : x.find((A) => A.slug === "customization_imagen_zoom_position")) == null ? void 0 : z.value), S = (v == null ? void 0 : v.success) && ((B = (R = v == null ? void 0 : v.data) == null ? void 0 : R.find((A) => A.slug === "customization_image_zoom_position_monogram")) == null ? void 0 : B.value);
    return S && P ? {
      position: S,
      image: P
    } : I && $ ? {
      position: $,
      image: I
    } : {
      position: null,
      image: null
    };
  };
  return b(Ct, {
    class: "tw-h-full",
    of: pt,
    onSubmit: (g) => {
      c(g);
    },
    get children() {
      const g = Cs.cloneNode(!0), v = g.firstChild, k = v.firstChild, I = k.nextSibling, P = I.firstChild, $ = P.firstChild, S = $.firstChild, j = S.nextSibling;
      j.nextSibling;
      const H = $.nextSibling, X = H.nextSibling, N = v.nextSibling, T = N.firstChild;
      return h(k, b(Bt, {
        get background() {
          var m;
          return ((m = w()) == null ? void 0 : m.image) || "";
        },
        get location() {
          var m;
          return ((m = w()) == null ? void 0 : m.position) || "center-left";
        },
        get children() {
          const m = Ps.cloneNode(!0);
          return h(m, b(it, {
            get each() {
              return f();
            },
            children: (x) => (() => {
              const z = As.cloneNode(!0);
              return G(z, "src", x), z;
            })()
          })), m;
        }
      })), h($, (() => {
        const m = V(() => !!e.id);
        return () => m() ? Number(e.id) : 1;
      })(), S), h($, () => window.customizationProduct.translations.customization["customization-text-of"], j), h($, () => $e.length, null), h(H, () => a().title.replace("__value__", Ot(r()))), h(X, () => {
        var m;
        return a().subtitle((m = o()) == null ? void 0 : m.min.toString());
      }), h(I, b(Ze, {
        get fallback() {
          return (() => {
            const m = Ts.cloneNode(!0);
            return m.$$click = () => t("/"), h(m, () => window.customizationProduct.translations.buttons["customization-home-button"]), D(() => m.disabled = !pt.dirty || pt.invalid), m;
          })();
        },
        get children() {
          return [b(jt, {
            get when() {
              return a().index === 0;
            },
            get children() {
              return b(js, {
                get productsByColor() {
                  return i();
                }
              });
            }
          }), b(jt, {
            get when() {
              return a().index === 1;
            },
            get children() {
              return b(Ds, {
                get min() {
                  var m;
                  return (m = o()) == null ? void 0 : m.min;
                },
                get max() {
                  var m;
                  return (m = o()) == null ? void 0 : m.max;
                },
                get products() {
                  var m;
                  return ((m = i()) == null ? void 0 : m[Qt().value].products) || [];
                }
              });
            }
          })];
        }
      }), null), h(N, b(K, {
        get when() {
          return !u();
        },
        get fallback() {
          return (() => {
            const m = Fs.cloneNode(!0);
            return h(m, () => window.customizationProduct.translations.buttons["customization-apply-button"]), D(() => m.disabled = pt.invalid || !pt.dirty), m;
          })();
        },
        get children() {
          const m = Ns.cloneNode(!0);
          return m.$$click = () => t(d()), h(m, () => window.customizationProduct.translations.buttons["customization-next-button"]), m;
        }
      }), T), T.$$click = () => {
        t("/");
      }, h(T, () => window.customizationProduct.translations.buttons["customization-button-cancel"]), g;
    }
  });
};
yt(["click"]);
const Ms = () => b(un, {}), Bs = /* @__PURE__ */ y('<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"></path></svg>'), Os = (t) => (() => {
  const e = Bs.cloneNode(!0);
  return D(() => G(e, "class", t.class)), e;
})(), Hs = /* @__PURE__ */ y('<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path></svg>'), Ws = (t) => (() => {
  const e = Hs.cloneNode(!0);
  return D(() => G(e, "class", t.class)), e;
})(), Fe = ze(), qs = ["title", "meta"], Be = (t) => t.tag + (t.name ? `.${t.name}"` : ""), Us = (t) => {
  if (!Dn.context) {
    const n = document.head.querySelectorAll("[data-sm]");
    Array.prototype.forEach.call(n, (o) => o.parentNode.removeChild(o));
  }
  const e = /* @__PURE__ */ new Map();
  function s(n) {
    if (n.ref)
      return n.ref;
    let o = document.querySelector(`[data-sm="${n.id}"]`);
    return o ? (o.tagName.toLowerCase() !== n.tag && (o.parentNode && o.parentNode.removeChild(o), o = document.createElement(n.tag)), o.removeAttribute("data-sm")) : o = document.createElement(n.tag), o;
  }
  const r = {
    addClientTag: (n) => {
      let o = Be(n);
      if (qs.indexOf(n.tag) !== -1) {
        e.has(o) || e.set(o, []);
        let l = e.get(o), a = l.length;
        l = [...l, n], e.set(o, l);
        {
          let u = s(n);
          n.ref = u, ct(u, n.props);
          let d = null;
          for (var i = a - 1; i >= 0; i--)
            if (l[i] != null) {
              d = l[i];
              break;
            }
          u.parentNode != document.head && document.head.appendChild(u), d && d.ref && document.head.removeChild(d.ref);
        }
        return a;
      }
      {
        let l = s(n);
        n.ref = l, ct(l, n.props), l.parentNode != document.head && document.head.appendChild(l);
      }
      return -1;
    },
    removeClientTag: (n, o) => {
      const i = Be(n);
      if (n.ref) {
        const l = e.get(i);
        if (l) {
          if (n.ref.parentNode) {
            n.ref.parentNode.removeChild(n.ref);
            for (let a = o - 1; a >= 0; a--)
              l[a] != null && document.head.appendChild(l[a].ref);
          }
          l[o] = null, e.set(i, l);
        } else
          n.ref.parentNode && n.ref.parentNode.removeChild(n.ref);
      }
    }
  };
  return b(Fe.Provider, {
    value: r,
    get children() {
      return t.children;
    }
  });
}, Ks = (t, e) => {
  const s = Rn();
  if (!te(Fe))
    throw new Error("<MetaProvider /> should be in the tree");
  return Js({
    tag: t,
    props: e,
    id: s,
    get name() {
      return e.name || e.property;
    }
  }), null;
};
function Js(t) {
  const {
    addClientTag: e,
    removeClientTag: s,
    addServerTag: r
  } = te(Fe);
  D(() => {
    {
      let n = e(t);
      Yt(() => s(t, n));
    }
  });
}
const vn = (t) => Ks("link", t), Gs = /* @__PURE__ */ y('<div class="tw-flex tw-flex-col"><label class="tw-typ-buttons-a" for="textId"></label><input class="tw-w-full tw-border-b tw-border-black tw-py-1" type="text" id="textId"></div>'), Zs = /* @__PURE__ */ y('<span class="tw-typ-small-1 tw-text-brand-tertiary"></span>'), Xs = /* @__PURE__ */ y('<span class="tw-typ-small-1 tw-text-tertiary"></span>'), Qs = /* @__PURE__ */ y('<div class="tw-flex tw-flex-col"><label class="tw-typ-buttons-a" for="fontId"></label><select class="tw-w-full tw-border-b tw-border-black tw-py-1" id="fontId"><option disabled value=""></option></select><span class="tw-typ-small-1 tw-text-brand-tertiary"></span></div>'), Ys = /* @__PURE__ */ y("<option></option>"), to = /* @__PURE__ */ y("<div>Error getting product data...</div>"), eo = /* @__PURE__ */ y('<div class="tw-left-[45%] tw-absolute tw-bottom-0 tw-top-0 tw-overflow-hidden"><p class=" tw-typ-small-1 tw-rotate-180 tw-text-white"></p></div>'), no = /* @__PURE__ */ y('<div class="tw-flex tw-h-full tw-flex-col tw-justify-between tw-gap-y-10"><div class="tw-flex tw-flex-col tw-gap-4"><h4 class="tw-typ-h4-subtopic-2 tw-my-2"></h4></div><div class="tw-flex tw-flex-col tw-gap-4"><button class="tw-button tw-button-primary" type="submit"></button><button class="tw-button tw-button-secondary"></button></div></div>'), ro = /* @__PURE__ */ y("<style></style>"), so = hn.pick({
  fontFamily: !0,
  textContent: !0,
  productIds: !0
}), $t = Pt({
  validate: St(so)
}), oo = _.array(_.object({
  family: _.string(),
  url: _.string(),
  label: _.string()
})), io = (t) => {
  const e = () => ({
    text: Gt(_.string().max(t.max, window.customizationProduct.translations.engraving["engraving-error-maximum"].replace("__value__", t.max.toString())).min(t.min, window.customizationProduct.translations.engraving["engraving-error-minimum"].replace("__value__", t.min.toString()))),
    font: Gt(_.string().min(1, window.customizationProduct.translations.engraving["engraving-error-font-empty"]))
  });
  return [b(ft, {
    of: $t,
    name: "textContent",
    get validate() {
      return e().text;
    },
    children: (s) => (() => {
      const r = Gs.cloneNode(!0), n = r.firstChild, o = n.nextSibling;
      return h(n, () => window.customizationProduct.translations.engraving["customization-engraving-item-1-text-2"]), ct(o, mt(() => s.props, {
        get maxLength() {
          return t.max;
        },
        get value() {
          return s.value;
        }
      }), !1, !1), h(r, (() => {
        const i = V(() => !!s.error);
        return () => i() ? (() => {
          const l = Zs.cloneNode(!0);
          return h(l, () => Zt($t, "textContent", {
            shouldTouched: !0
          })), l;
        })() : (() => {
          const l = Xs.cloneNode(!0);
          return h(l, () => window.customizationProduct.translations.engraving["customization-engraving-item-1-text-3"].replace("__value__", String(t.max))), l;
        })();
      })(), null), r;
    })()
  }), b(ft, {
    of: $t,
    name: "fontFamily",
    get validate() {
      return e().font;
    },
    children: (s) => (() => {
      const r = Qs.cloneNode(!0), n = r.firstChild, o = n.nextSibling, i = o.firstChild, l = o.nextSibling;
      return h(n, () => window.customizationProduct.translations.engraving["customization-engraving-item-1-text-4"]), ct(o, mt({
        get value() {
          return s.value;
        }
      }, () => s.props), !1, !0), h(i, () => window.customizationProduct.translations.engraving["engraving-font-empty"]), h(o, b(it, {
        get each() {
          return t.fonts;
        },
        children: (a) => (() => {
          const u = Ys.cloneNode(!0);
          return h(u, () => a.label), D(() => u.value = a.label), u;
        })()
      }), null), h(l, () => Zt($t, "fontFamily", {
        shouldTouched: !0
      })), D(() => i.selected = !s.value), r;
    })()
  })];
}, ao = () => {
  const [t] = zt();
  At(window.customizationProduct.translations.tittles["engraving-title"]), de(() => {
    var a;
    E($t, "fontFamily", M(C, "engraving.fontFamily", {
      shouldActive: !1
    }) || "", {
      shouldDirty: !1
    }), E($t, "textContent", M(C, "engraving.textContent", {
      shouldActive: !1
    }) || "", {
      shouldDirty: !1
    }), E($t, "productIds", ((a = M(C, "engraving.productIds", {
      shouldActive: !1
    })) == null ? void 0 : a.map((u) => `gid://shopify/ProductVariant/${u}`)) || [], {
      shouldDirty: !1
    });
  });
  const e = dt(), s = (a) => {
    var d;
    const u = kt(((d = r()) == null ? void 0 : d.variants.nodes[0].id) || "");
    E(C, "engraving.productIds", [u], {
      shouldValidate: !1
    }), E(C, "engraving.fontFamily", a.fontFamily, {
      shouldValidate: !1
    }), E(C, "engraving.textContent", a.textContent, {
      shouldValidate: !1
    }), e("/");
  }, r = () => {
    var a, u;
    return (u = (a = t()) == null ? void 0 : a.collection) == null ? void 0 : u.products.nodes[0];
  }, n = () => {
    var a, u, d;
    return It(((d = (u = (a = t()) == null ? void 0 : a.collection) == null ? void 0 : u.metafield) == null ? void 0 : d.value) || "", "collection");
  }, o = () => {
    var g, v, k, I, P, $, S, j, H, X;
    const a = n(), u = xt.currentProductAttributes(), d = xt.currentProductAssets();
    if (!a.success && !u.success && !d.success)
      return null;
    const c = (a == null ? void 0 : a.success) && ((k = (v = (g = a.data) == null ? void 0 : g.assets) == null ? void 0 : v.find((N) => {
      var T;
      return (T = N.tags) == null ? void 0 : T.split(",").includes("category-base-product-image-with-zoom-default");
    })) == null ? void 0 : k.uri_internal), p = (d == null ? void 0 : d.success) && ((P = (I = d.data) == null ? void 0 : I.find((N) => (N == null ? void 0 : N.type) === "product_base_product_image_with_zoom_engraving")) == null ? void 0 : P.uri_internal), f = a.success && ((j = (S = ($ = a.data) == null ? void 0 : $.category_attributes) == null ? void 0 : S.find((N) => N.slug === "customization_imagen_zoom_position")) == null ? void 0 : j.value), w = (u == null ? void 0 : u.success) && ((X = (H = u == null ? void 0 : u.data) == null ? void 0 : H.find((N) => N.slug === "customization_image_zoom_position_engraving")) == null ? void 0 : X.value);
    return w && p ? {
      position: w,
      image: p
    } : c && f ? {
      position: f,
      image: c
    } : {
      position: null,
      image: null
    };
  }, i = V(() => {
    var c, p, f, w;
    const a = n();
    if (!a.success)
      return null;
    const u = Number((p = (c = a == null ? void 0 : a.data.category_attributes) == null ? void 0 : c.find((g) => g.slug === "maximum-selection")) == null ? void 0 : p.value), d = Number((w = (f = a == null ? void 0 : a.data.category_attributes) == null ? void 0 : f.find((g) => g.slug === "minimum-selection")) == null ? void 0 : w.value);
    return {
      max: u,
      min: d
    };
  }), l = V(() => {
    var c, p, f;
    const a = n();
    if (!a.success)
      return null;
    const u = a.success && ((f = (p = (c = a.data) == null ? void 0 : c.category_attributes) == null ? void 0 : p.find((w) => w.slug === "available_fonts")) == null ? void 0 : f.value), d = oo.safeParse(JSON.parse(u || "[]"));
    return d.success ? d.data : null;
  });
  return n().success ? [b(it, {
    get each() {
      return l();
    },
    children: (a) => b(K, {
      get when() {
        return a.url.startsWith("https://fonts.google");
      },
      get fallback() {
        return (() => {
          const u = ro.cloneNode(!0);
          return h(u, () => `
              @font-face {
                font-family: '${a.family}';
                font-style: normal;
                font-weight: 400;
                src: url('${a.url}') format('woff2');
              }
            `), u;
        })();
      },
      get children() {
        return b(vn, {
          get href() {
            return `${a.url}`;
          },
          rel: "stylesheet"
        });
      }
    })
  }), b(Ct, {
    of: $t,
    onSubmit: (a) => {
      s(a);
    },
    class: "tw-h-full",
    get children() {
      const a = no.cloneNode(!0), u = a.firstChild, d = u.firstChild, c = u.nextSibling, p = c.firstChild, f = p.nextSibling;
      return h(u, b(Bt, {
        get background() {
          var w;
          return ((w = o()) == null ? void 0 : w.image) || "";
        },
        get location() {
          var w;
          return ((w = o()) == null ? void 0 : w.position) || "center-center";
        },
        get children() {
          const w = eo.cloneNode(!0), g = w.firstChild;
          return g.style.setProperty("writing-mode", "vertical-rl"), g.style.setProperty("white-space", "nowrap"), h(g, () => M($t, "textContent")), D(() => g.style.setProperty("font-family", M($t, "fontFamily"))), w;
        }
      }), d), h(d, () => window.customizationProduct.translations.engraving["customization-engraving-item-1-text-1"].replace("__value__", Ot(t()))), h(u, b(io, {
        get min() {
          var w;
          return (w = i()) == null ? void 0 : w.min;
        },
        get max() {
          var w;
          return (w = i()) == null ? void 0 : w.max;
        },
        get fonts() {
          return l() || [];
        }
      }), null), h(p, () => window.customizationProduct.translations.buttons["customization-apply-button"]), f.$$click = () => e("/"), h(f, () => window.customizationProduct.translations.buttons["customization-button-cancel"]), a;
    }
  })] : to.cloneNode(!0);
};
yt(["click"]);
const ue = _.object({
  productIds: _.array(_.string())
}), lo = _.object({
  singleStickers: ue,
  bundleStickers: ue
}), vt = Pt({
  validate: St(lo),
  initialValues: {
    bundleStickers: {
      productIds: []
    },
    singleStickers: {
      productIds: []
    }
  }
}), bt = Pt({
  validate: St(ue)
}), _t = Pt({
  validate: St(ue)
}), Oe = /* @__PURE__ */ y('<li class="tw-mb-6 tw-cursor-pointer"><figure><img loading="lazy" alt="banner" class="tw-mb-3 tw-h-[150px] tw-w-full tw-object-cover"><p class="tw-typ-h4-subtopic-2"></p></figure></li>'), co = /* @__PURE__ */ y('<div class="tw-flex tw-flex-col tw-gap-4"><button class="tw-button tw-button-primary" type="submit"></button><button class="tw-button tw-button-secondary"></button></div>'), uo = /* @__PURE__ */ y('<div class="tw-flex tw-h-full tw-flex-col tw-justify-between tw-gap-y-10"><ul></ul></div>'), po = () => {
  const t = dt(), [e, s] = zt(), [r] = e(), [n] = s(), o = ee();
  de(() => {
    var c, p, f, w;
    o.state === "home" && (E(bt, "productIds", ((c = M(C, "bundleStickers.productIds", {
      shouldActive: !1
    })) == null ? void 0 : c.map((g) => `gid://shopify/ProductVariant/${g}`)) || [], {
      shouldDirty: !1
    }), E(_t, "productIds", ((p = M(C, "singleStickers.productIds", {
      shouldActive: !1
    })) == null ? void 0 : p.map((g) => `gid://shopify/ProductVariant/${g}`)) || [], {
      shouldDirty: !1
    }), E(vt, "bundleStickers.productIds", ((f = M(C, "bundleStickers.productIds", {
      shouldActive: !1
    })) == null ? void 0 : f.map((g) => `gid://shopify/ProductVariant/${g}`)) || [], {
      shouldDirty: !1
    }), E(vt, "singleStickers.productIds", ((w = M(C, "singleStickers.productIds", {
      shouldActive: !1
    })) == null ? void 0 : w.map((g) => `gid://shopify/ProductVariant/${g}`)) || [], {
      shouldDirty: !1
    }));
  }), At(window.customizationProduct.translations.customization["customization-make-it-yours-title"]);
  const i = (c, p) => {
    var w;
    if (((w = p.submitter) == null ? void 0 : w.getAttribute("type")) !== "submit") {
      C.internal.setSubmitted(!1);
      return;
    }
    if (c != null && c.bundleStickers) {
      const g = c.bundleStickers.productIds.map(kt);
      g && E(C, "bundleStickers.productIds", g, {
        shouldValidate: !1
      });
    }
    if (c != null && c.singleStickers) {
      const g = c.singleStickers.productIds.map(kt);
      g && E(C, "singleStickers.productIds", g, {
        shouldValidate: !1
      });
    }
    (c != null && c.bundleStickers || c != null && c.singleStickers) && t("/");
  }, l = () => {
    st(vt, "bundleStickers.productIds"), st(vt, "singleStickers.productIds"), st(C, ["bundleStickers.productIds", "singleStickers.productIds"]), t("/");
  }, a = () => {
    var c, p, f, w, g, v;
    return {
      single: It(((f = (p = (c = r()) == null ? void 0 : c.collection) == null ? void 0 : p.metafield) == null ? void 0 : f.value) || "", "collection"),
      bundle: It(((v = (g = (w = n()) == null ? void 0 : w.collection) == null ? void 0 : g.metafield) == null ? void 0 : v.value) || "", "collection")
    };
  }, u = () => {
    var w, g, v, k, I, P;
    const c = a();
    if (!c.bundle.success && !c.single.success)
      return null;
    const p = (c == null ? void 0 : c.bundle.success) && ((v = (g = (w = c.bundle.data) == null ? void 0 : w.assets) == null ? void 0 : g.find(($) => {
      var S;
      return (S = $.tags) == null ? void 0 : S.split(",").includes("banner_customization");
    })) == null ? void 0 : v.uri_internal), f = (c == null ? void 0 : c.single.success) && ((P = (I = (k = c.single.data) == null ? void 0 : k.assets) == null ? void 0 : I.find(($) => {
      var S;
      return (S = $.tags) == null ? void 0 : S.split(",").includes("banner_customization");
    })) == null ? void 0 : P.uri_internal);
    return {
      bundleBanner: p,
      singleBanner: f
    };
  }, d = () => ({
    bundle: M(vt, "bundleStickers.productIds", {
      shouldActive: !1
    }),
    single: M(vt, "singleStickers.productIds", {
      shouldActive: !1
    })
  });
  return b(Ct, {
    shouldActive: !1,
    of: vt,
    onSubmit: i,
    class: "tw-h-full",
    get children() {
      const c = uo.cloneNode(!0), p = c.firstChild;
      return h(p, b(K, {
        get when() {
          var f, w;
          return (w = (f = r()) == null ? void 0 : f.collection) == null ? void 0 : w.products.nodes.some((g) => g.variants.nodes[0].availableForSale);
        },
        get children() {
          const f = Oe.cloneNode(!0), w = f.firstChild, g = w.firstChild, v = g.nextSibling;
          return f.$$click = () => t("/stickers/single"), h(v, () => window.customizationProduct.translations.stickers["customization-stickers-item-1-text-1"].replace("__value__", Ot(r()))), D(() => {
            var k;
            return G(g, "src", ((k = u()) == null ? void 0 : k.singleBanner) || "");
          }), f;
        }
      }), null), h(p, b(K, {
        get when() {
          var f, w;
          return (w = (f = n()) == null ? void 0 : f.collection) == null ? void 0 : w.products.nodes.some((g) => g.variants.nodes[0].availableForSale);
        },
        get children() {
          const f = Oe.cloneNode(!0), w = f.firstChild, g = w.firstChild, v = g.nextSibling;
          return f.$$click = () => t("/stickers/bundle"), h(v, () => window.customizationProduct.translations.stickers["customization-stickers-item-1-text-2"].replace("__value__", Ot(n()))), D(() => {
            var k;
            return G(g, "src", ((k = u()) == null ? void 0 : k.bundleBanner) || "");
          }), f;
        }
      }), null), h(c, b(K, {
        get when() {
          var f, w;
          return Number((f = d().bundle) == null ? void 0 : f.length) > 0 || Number((w = d().single) == null ? void 0 : w.length) > 0;
        },
        get children() {
          const f = co.cloneNode(!0), w = f.firstChild, g = w.nextSibling;
          return h(w, () => window.customizationProduct.translations.buttons.done), g.$$click = () => l(), h(g, () => window.customizationProduct.translations.buttons["customization-button-cancel"]), f;
        }
      }), null), c;
    }
  });
};
yt(["click"]);
const go = /* @__PURE__ */ y('<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"></path></svg>'), yn = (t) => (() => {
  const e = go.cloneNode(!0);
  return D(() => G(e, "class", t.class)), e;
})(), mo = /* @__PURE__ */ y("<div>Error getting product data...</div>"), fo = /* @__PURE__ */ y('<div class="tw-flex tw-h-full tw-flex-col tw-justify-between tw-gap-y-10"><div class="tw-flex tw-justify-center"></div><div class="tw-flex tw-flex-col tw-gap-5"><div><p class="tw-typ-h5-subtopic-3-a"></p><p class="tw-typ-body-2 tw-text-secondary"></p></div></div><div class="tw-flex tw-flex-col tw-gap-4"><button class="tw-button tw-button-primary" type="submit"></button><button class="tw-button tw-button-secondary"></button></div></div>'), wo = /* @__PURE__ */ y('<img class="tw-h-full tw-w-full tw-object-contain" alt="Image">'), ho = /* @__PURE__ */ y('<div class="tw-custom-scrollbar tw-flex tw-flex-auto tw-flex-nowrap tw-gap-6 tw-overflow-auto tw-py-2"></div>'), bo = /* @__PURE__ */ y('<p class="tw-typ-small-1 tw-text-brand-tertiary"></p>'), _o = /* @__PURE__ */ y('<div class="tw-relative tw-inline tw-h-[100px] tw-flex-shrink-0"><input type="checkbox" class="tw-peer !tw-hidden"><span class="tw-absolute tw-inset-0 tw-hidden tw-cursor-not-allowed tw-bg-background tw-bg-opacity-75 peer-disabled:tw-block"></span><label class="tw-block tw-h-full tw-w-full tw-select-none tw-border tw-border-transparent peer-checked:tw-border-primary peer-disabled:tw-cursor-not-allowed"><img class="tw-h-full tw-w-full tw-object-contain tw-px-2"></label></div>'), vo = /* @__PURE__ */ y('<div class="tw-relative tw-inline tw-h-[100px] tw-flex-shrink-0"><input type="checkbox" class="tw-peer !tw-hidden" id="single_sticker_product_select_empty" value="reset"><span class="tw-absolute tw-inset-0 tw-hidden tw-cursor-not-allowed tw-bg-background tw-bg-opacity-75 peer-disabled:tw-block"></span><label for="single_sticker_product_select_empty" class="tw-block tw-h-full tw-w-full tw-select-none tw-border tw-border-transparent peer-checked:tw-border-primary peer-disabled:tw-cursor-not-allowed"><div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-between tw-p-2"><span class="tw-mx-auto tw-mt-3 tw-w-10"></span><span class="tw-typ-body-3"></span></div></label></div>'), yo = () => {
  const [t, e] = zt(), [s] = e();
  At(window.customizationProduct.translations.customization["customization-stickers-bundle-title"]);
  const r = dt(), n = () => {
    var c, p, f;
    return It(((f = (p = (c = s()) == null ? void 0 : c.collection) == null ? void 0 : p.metafield) == null ? void 0 : f.value) || "", "collection");
  }, o = (c) => {
    if (!c.productIds)
      return;
    const p = c.productIds.map(kt);
    c.productIds.some((f) => f === "reset") ? st(vt, "bundleStickers.productIds") : E(vt, "bundleStickers.productIds", p, {
      shouldValidate: !1
    }), r("/stickers");
  }, i = V(() => {
    var w, g, v, k;
    const c = n();
    if (!c.success)
      return null;
    const p = Number((g = (w = c == null ? void 0 : c.data.category_attributes) == null ? void 0 : w.find((I) => I.slug === "maximum-selection")) == null ? void 0 : g.value), f = Number((k = (v = c == null ? void 0 : c.data.category_attributes) == null ? void 0 : v.find((I) => I.slug === "minimum-selection")) == null ? void 0 : k.value);
    return {
      max: p,
      min: f
    };
  }), l = () => M(bt, "productIds", {
    shouldActive: !1
  }), a = () => {
    var c, p;
    return (p = (c = s()) == null ? void 0 : c.collection) == null ? void 0 : p.products.nodes;
  }, u = V(() => {
    var p, f, w;
    return (w = (f = (p = a()) == null ? void 0 : p.find((g) => {
      var v;
      return g.variants.nodes[0].id === ((v = l()) == null ? void 0 : v.at(-1));
    })) == null ? void 0 : f.featuredImage) == null ? void 0 : w.url;
  }), d = () => {
    var I, P, $, S, j, H, X, N, T, m;
    const c = n(), p = xt.currentProductAttributes(), f = xt.currentProductAssets();
    if (!c.success && !p.success && !f.success)
      return null;
    const w = (c == null ? void 0 : c.success) && (($ = (P = (I = c.data) == null ? void 0 : I.assets) == null ? void 0 : P.find((x) => {
      var z;
      return (z = x.tags) == null ? void 0 : z.split(",").includes("category-base-product-image-with-zoom-default");
    })) == null ? void 0 : $.uri_internal), g = (f == null ? void 0 : f.success) && ((j = (S = f.data) == null ? void 0 : S.find((x) => (x == null ? void 0 : x.type) === "product_base_product_image_with_zoom_bundle_stickers")) == null ? void 0 : j.uri_internal), v = c.success && ((N = (X = (H = c.data) == null ? void 0 : H.category_attributes) == null ? void 0 : X.find((x) => x.slug === "customization_imagen_zoom_position")) == null ? void 0 : N.value), k = (p == null ? void 0 : p.success) && ((m = (T = p == null ? void 0 : p.data) == null ? void 0 : T.find((x) => x.slug === "customization_image_zoom_position_bundle_stickers")) == null ? void 0 : m.value);
    return k && g ? {
      position: k,
      image: g
    } : w && v ? {
      position: v,
      image: w
    } : {
      position: null,
      image: null
    };
  };
  return n().success ? b(Ct, {
    of: bt,
    onSubmit: (c) => {
      o(c);
    },
    class: "tw-h-full",
    get children() {
      const c = fo.cloneNode(!0), p = c.firstChild, f = p.nextSibling, w = f.firstChild, g = w.firstChild, v = g.nextSibling, k = f.nextSibling, I = k.firstChild, P = I.nextSibling;
      return h(p, b(K, {
        keyed: !0,
        get when() {
          var $;
          return V(() => {
            var S;
            return !!((S = d()) != null && S.image);
          })() && (($ = d()) == null ? void 0 : $.position);
        },
        get fallback() {
          return b(Bt, {
            get background() {
              return u() || "";
            }
          });
        },
        get children() {
          return b(Bt, {
            get background() {
              var $;
              return (($ = d()) == null ? void 0 : $.image) || "";
            },
            get location() {
              var $;
              return (($ = d()) == null ? void 0 : $.position) || "center-center";
            },
            get children() {
              return b(K, {
                keyed: !0,
                get when() {
                  return u();
                },
                children: ($) => (() => {
                  const S = wo.cloneNode(!0);
                  return G(S, "src", $), S;
                })()
              });
            }
          });
        }
      })), h(g, () => window.customizationProduct.translations.stickers["customization-stickers-item-1-text-2"].replace("__value__", Ot(s()))), h(v, () => window.customizationProduct.translations.stickers["customization-stickers-item-3-text-1"]), h(f, b($o, {
        get min() {
          var $;
          return ($ = i()) == null ? void 0 : $.min;
        },
        get max() {
          var $;
          return ($ = i()) == null ? void 0 : $.max;
        },
        get products() {
          return a() || [];
        }
      }), null), h(I, () => window.customizationProduct.translations.buttons["customization-apply-button"]), P.$$click = () => r("/"), h(P, () => window.customizationProduct.translations.buttons["customization-button-cancel"]), c;
    }
  }) : mo.cloneNode(!0);
}, $o = (t) => {
  const e = () => Gt(_.array(_.string()).max(t.max, window.customizationProduct.translations.stickers["stickers-error-maximum"].replace("__value__", t.max.toString())).min(t.min, window.customizationProduct.translations.stickers["stickers-error-minimum"].replace("__value__", t.min.toString()))), s = () => M(bt, "productIds");
  return Ht(() => {
    const r = M(bt, "productIds");
    r && (r == null ? void 0 : r.length) > t.max && E(bt, "productIds", r.slice(1));
  }), [(() => {
    const r = ho.cloneNode(!0);
    return h(r, b(it, {
      get each() {
        return t.products;
      },
      children: (n) => b(ft, {
        of: bt,
        name: "productIds",
        get validate() {
          return e();
        },
        children: (o) => (() => {
          const i = _o.cloneNode(!0), l = i.firstChild, a = l.nextSibling, u = a.nextSibling, d = u.firstChild;
          return l.$$click = () => {
            var c;
            E(bt, "productIds", ((c = s()) == null ? void 0 : c.filter((p) => p !== "reset")) || []);
          }, ct(l, mt({
            get id() {
              return `single_sticker_product_select_${n.variants.nodes[0].id}`;
            },
            get value() {
              return n.variants.nodes[0].id;
            },
            get checked() {
              var c;
              return (c = o.value) == null ? void 0 : c.includes(n.variants.nodes[0].id);
            }
          }, () => o.props, {
            get disabled() {
              return !n.variants.nodes[0].availableForSale;
            }
          }), !1, !1), D((c) => {
            var w;
            const p = `single_sticker_product_select_${n.variants.nodes[0].id}`, f = ((w = n.featuredImage) == null ? void 0 : w.url) || "";
            return p !== c._v$ && G(u, "for", c._v$ = p), f !== c._v$2 && G(d, "src", c._v$2 = f), c;
          }, {
            _v$: void 0,
            _v$2: void 0
          }), i;
        })()
      })
    }), null), h(r, b(ft, {
      of: bt,
      name: "productIds",
      get validate() {
        return e();
      },
      children: (n) => (() => {
        const o = vo.cloneNode(!0), i = o.firstChild, l = i.nextSibling, a = l.nextSibling, u = a.firstChild, d = u.firstChild, c = d.nextSibling;
        return ct(i, mt({
          get checked() {
            var p;
            return (p = n.value) == null ? void 0 : p.includes("reset");
          }
        }, () => n.props, {
          onClick: () => {
            E(bt, "productIds", ["reset"]);
          }
        }), !1, !1), h(d, b(yn, {})), h(c, () => window.customizationProduct.translations.stickers.noStickers), o;
      })()
    }), null), r;
  })(), (() => {
    const r = bo.cloneNode(!0);
    return h(r, () => Zt(bt, "productIds", {
      shouldTouched: !0
    })), r;
  })()];
};
yt(["click"]);
const xo = /* @__PURE__ */ y("<div>Error getting product data...</div>"), ko = /* @__PURE__ */ y('<div class="tw-flex tw-h-full tw-flex-col tw-justify-between tw-gap-y-10"><div class="tw-flex tw-justify-center"></div><div class="tw-flex tw-flex-col tw-gap-5"><div><p class="tw-typ-h5-subtopic-3-a"></p><p class="tw-typ-body-2 tw-text-secondary"></p></div></div><div class="tw-flex tw-flex-col tw-gap-4"><button class="tw-button tw-button-primary" type="submit"></button><button class="tw-button tw-button-secondary"></button></div></div>'), Io = /* @__PURE__ */ y('<div class="tw-custom-scrollbar tw-flex tw-flex-auto tw-flex-nowrap tw-gap-6 tw-overflow-auto tw-py-2"></div>'), zo = /* @__PURE__ */ y('<p class="tw-typ-small-1 tw-text-brand-tertiary"></p>'), So = /* @__PURE__ */ y('<div class="tw-relative tw-inline tw-h-[100px] tw-flex-shrink-0"><input type="checkbox" class="tw-peer !tw-hidden"><span class="tw-absolute tw-inset-0 tw-hidden tw-cursor-not-allowed tw-bg-background tw-bg-opacity-75 peer-disabled:tw-block"></span><label class="tw-block tw-h-full tw-w-full tw-select-none tw-border tw-border-transparent peer-checked:tw-border-primary peer-disabled:tw-cursor-not-allowed"><img class="tw-h-full tw-w-full tw-object-contain tw-px-2"></label></div>'), Po = /* @__PURE__ */ y('<div class="tw-relative tw-inline tw-h-[100px] tw-flex-shrink-0"><input type="checkbox" class="tw-peer !tw-hidden" id="single_sticker_product_select_empty" value="reset"><span class="tw-absolute tw-inset-0 tw-hidden tw-cursor-not-allowed tw-bg-background tw-bg-opacity-75 peer-disabled:tw-block"></span><label for="single_sticker_product_select_empty" class="tw-block tw-h-full tw-w-full tw-select-none tw-border tw-border-transparent peer-checked:tw-border-primary peer-disabled:tw-cursor-not-allowed"><div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-between tw-p-2"><span class="tw-mx-auto tw-mt-3 tw-w-10"></span><span class="tw-typ-body-3"></span></div></label></div>'), No = () => {
  const [t] = zt(), [e] = t(), s = dt();
  At(window.customizationProduct.translations.customization["customization-stickers-single-title"]);
  const r = () => {
    var u, d, c;
    return It(((c = (d = (u = e()) == null ? void 0 : u.collection) == null ? void 0 : d.metafield) == null ? void 0 : c.value) || "", "collection");
  }, n = (u) => {
    if (!u.productIds)
      return;
    const d = u.productIds.map(kt);
    u.productIds.some((c) => c === "reset") ? st(vt, "singleStickers.productIds") : E(vt, "singleStickers.productIds", d, {
      shouldValidate: !1
    }), s("/stickers");
  }, o = V(() => {
    var p, f, w, g;
    const u = r();
    if (!u.success)
      return null;
    const d = Number((f = (p = u == null ? void 0 : u.data.category_attributes) == null ? void 0 : p.find((v) => v.slug === "maximum-selection")) == null ? void 0 : f.value), c = Number((g = (w = u == null ? void 0 : u.data.category_attributes) == null ? void 0 : w.find((v) => v.slug === "minimum-selection")) == null ? void 0 : g.value);
    return {
      max: d,
      min: c
    };
  }), i = () => M(_t, "productIds", {
    shouldActive: !1
  }), l = () => {
    var u, d;
    return (d = (u = e()) == null ? void 0 : u.collection) == null ? void 0 : d.products.nodes;
  }, a = V(() => {
    var d, c, p;
    return (p = (c = (d = l()) == null ? void 0 : d.find((f) => {
      var w;
      return f.variants.nodes[0].id === ((w = i()) == null ? void 0 : w.at(-1));
    })) == null ? void 0 : c.featuredImage) == null ? void 0 : p.url;
  });
  return r().success ? b(Ct, {
    of: _t,
    onSubmit: (u) => {
      n(u);
    },
    class: "tw-h-full",
    get children() {
      const u = ko.cloneNode(!0), d = u.firstChild, c = d.nextSibling, p = c.firstChild, f = p.firstChild, w = f.nextSibling, g = c.nextSibling, v = g.firstChild, k = v.nextSibling;
      return h(d, b(Bt, {
        get background() {
          return a() || "";
        }
      })), h(f, () => window.customizationProduct.translations.stickers["customization-stickers-item-1-text-1"].replace("__value__", Ot(e()))), h(w, () => {
        var I;
        return window.customizationProduct.translations.stickers["customization-stickers-item-2-text-2"].replace("__value__", String((I = o()) == null ? void 0 : I.min));
      }), h(c, b(Co, {
        get min() {
          var I;
          return (I = o()) == null ? void 0 : I.min;
        },
        get max() {
          var I;
          return (I = o()) == null ? void 0 : I.max;
        },
        get products() {
          return l() || [];
        }
      }), null), h(v, () => window.customizationProduct.translations.buttons["customization-apply-button"]), k.$$click = () => s("/"), h(k, () => window.customizationProduct.translations.buttons["customization-button-cancel"]), u;
    }
  }) : xo.cloneNode(!0);
}, Co = (t) => {
  const e = () => Gt(_.array(_.string()).max(t.max, window.customizationProduct.translations.stickers["stickers-error-maximum"].replace("__value__", t.max.toString())).min(t.min, window.customizationProduct.translations.stickers["stickers-error-minimum"].replace("__value__", t.min.toString()))), s = () => M(_t, "productIds");
  return Ht(() => {
    const r = M(_t, "productIds");
    r && (r == null ? void 0 : r.length) > t.max && E(_t, "productIds", r.slice(1));
  }), [(() => {
    const r = Io.cloneNode(!0);
    return h(r, b(it, {
      get each() {
        return t.products;
      },
      children: (n) => b(ft, {
        of: _t,
        name: "productIds",
        get validate() {
          return e();
        },
        children: (o) => (() => {
          const i = So.cloneNode(!0), l = i.firstChild, a = l.nextSibling, u = a.nextSibling, d = u.firstChild;
          return ct(l, mt({
            get id() {
              return `single_sticker_product_select_${n.variants.nodes[0].id}`;
            },
            get value() {
              return n.variants.nodes[0].id;
            },
            get checked() {
              var c;
              return (c = o.value) == null ? void 0 : c.includes(n.variants.nodes[0].id);
            }
          }, () => o.props, {
            onClick: () => {
              var c;
              E(_t, "productIds", ((c = s()) == null ? void 0 : c.filter((p) => p !== "reset")) || []);
            },
            get disabled() {
              return !n.variants.nodes[0].availableForSale;
            }
          }), !1, !1), D((c) => {
            var w;
            const p = `single_sticker_product_select_${n.variants.nodes[0].id}`, f = ((w = n.featuredImage) == null ? void 0 : w.url) || "";
            return p !== c._v$ && G(u, "for", c._v$ = p), f !== c._v$2 && G(d, "src", c._v$2 = f), c;
          }, {
            _v$: void 0,
            _v$2: void 0
          }), i;
        })()
      })
    }), null), h(r, b(ft, {
      of: _t,
      name: "productIds",
      get validate() {
        return e();
      },
      children: (n) => (() => {
        const o = Po.cloneNode(!0), i = o.firstChild, l = i.nextSibling, a = l.nextSibling, u = a.firstChild, d = u.firstChild, c = d.nextSibling;
        return ct(i, mt({
          get checked() {
            var p;
            return (p = n.value) == null ? void 0 : p.includes("reset");
          }
        }, () => n.props, {
          onClick: () => {
            E(_t, "productIds", ["reset"]);
          }
        }), !1, !1), h(d, b(yn, {})), h(c, () => window.customizationProduct.translations.stickers.noStickers), o;
      })()
    }), null), r;
  })(), (() => {
    const r = zo.cloneNode(!0);
    return h(r, () => Zt(_t, "productIds", {
      shouldTouched: !0
    })), r;
  })()];
};
yt(["click"]);
const Ao = ({ length: t }) => {
  const e = Array.from(
    { length: t },
    () => {
    }
  );
  return {
    inputElements: e,
    keydownEventHandler: (n, o, i) => {
      var l;
      (n.key === "Backspace" || n.key === "Delete") && (n.currentTarget && n.currentTarget.value === "" && ((l = e[Math.max(0, o - 1)]) == null || l.focus()), i == null || i(n, o));
    },
    inputEventHandler: (n, o) => {
      var d;
      const [i, ...l] = n.currentTarget.value, a = e.length - 1;
      n.currentTarget.value = i ?? "";
      const u = Math.min(o + l.length, a);
      l.length > 0 && e.slice(o + 1, u + 1).forEach((c, p) => {
        c && (c.value = l[p]);
      }), i !== void 0 && ((d = e[Math.min(u + 1, a)]) == null || d.focus());
    }
  };
}, To = /* @__PURE__ */ y('<div class="tw-flex tw-w-full tw-justify-center tw-gap-2"></div>'), Fo = /* @__PURE__ */ y('<div class="tw-flex tw-gap-5 tw-px-1.5"></div>'), Eo = /* @__PURE__ */ y('<div class="tw-absolute tw-inset-0 tw-flex tw-h-full tw-w-full tw-justify-center tw-p-4 [&amp;>svg]:tw-h-full [&amp;>svg]:tw-w-2/3"></div>'), Vo = /* @__PURE__ */ y('<div class="border tw-relative tw-h-20 tw-w-full tw-border tw-border-primary"><input type="text" name="customization-tags-view-selector-characters"></div>'), jo = /* @__PURE__ */ y('<button class="tw-aspect-square tw-h-8 [&amp;>svg]:tw-h-full [&amp;>svg]:tw-w-full"></button>'), Do = /* @__PURE__ */ y('<div class="tw-grid tw-w-full tw-grid-cols-2 tw-gap-4 "></div>'), $n = /* @__PURE__ */ y('<div class="tw-h-20 tw-w-full"><input type="radio" class="tw-peer tw-hidden"></div>'), xn = /* @__PURE__ */ y('<span class="tw-mr-1"></span>'), Ro = /* @__PURE__ */ y('<span class="tw-mr-1 tw-uppercase"></span>'), Lo = /* @__PURE__ */ y('<div class="tw-flex tw-items-center tw-gap-2 tw-py-2"></div>'), Mo = /* @__PURE__ */ y('<div class="tw-grid tw-w-full tw-grid-cols-3 tw-gap-4 "></div>'), Bo = /* @__PURE__ */ y('<p class="tw-typ-body-2 tw-text-tertiary"></p>'), He = /* @__PURE__ */ y("<span></span>"), Oo = /* @__PURE__ */ y('<div class="tw-h-20 tw-w-full"><input type="radio" class="tw-peer tw-hidden" id="customization_drawer_tags_product-id-both"></div>'), Ho = /* @__PURE__ */ y('<div class="tw-flex tw-h-full tw-items-center tw-justify-center [&amp;_svg]:tw-h-8 [&amp;_svg]:tw-w-8"></div>'), Wo = /* @__PURE__ */ y('<button class="tw-button tw-button-primary"></button>'), We = /* @__PURE__ */ y('<button class="tw-button tw-button-secondary"></button>'), qo = /* @__PURE__ */ y('<div class="tw-flex tw-h-full tw-flex-col tw-justify-between tw-gap-y-10"><div class="tw-flex tw-flex-col tw-gap-6"><div class="tw-flex tw-flex-col tw-justify-center tw-gap-4"><div class="tw-flex tw-w-full tw-items-end"></div><div class="tw-w-full"></div></div><div class="tw-flex tw-flex-col tw-gap-5 tw-px-1.5"><div><p class="tw-typ-h5-subtopic-3-a tw-text-tertiary"> <!> </p><p class="tw-typ-h3-subtopic-1-b tw-text-secondary"></p><p class="tw-typ-body-1 tw-text-tertiary"></p></div></div></div><div class="tw-flex tw-flex-col tw-gap-4"></div></div>'), Uo = /* @__PURE__ */ y("<style></style>"), Ko = /* @__PURE__ */ y('<div class="tw-w-full"><input type="radio" class="tw-peer tw-sr-only" name="customization-tags-view-selector"><label class="tw-typ-body-2 tw-block tw-w-full tw-grow tw-cursor-pointer tw-border-b tw-py-2 tw-text-center peer-checked:tw-border-b-2 peer-checked:tw-border-primary peer-checked:tw-pb-[7px]"></label></div>'), Jo = /* @__PURE__ */ y('<span class="tw-mr-1 tw-text-2xl tw-uppercase"></span>'), Go = /* @__PURE__ */ y('<button type="submit" class="tw-button tw-button-primary"></button>'), kn = /^[a-zA-Z0-9]+$/, [Zo, Xo] = O([]), Ut = _.object({
  color: _.string().min(1),
  font: _.string().min(1),
  letters: _.array(_.lazy(() => _.union([_.string().regex(kn), _.null(), _.undefined(), ...Zo().map((t) => _.literal(t))]))).min(1).max(3).refine((t) => t.some((e) => e !== null), {
    message: "At least one letter is required"
  }),
  productIds: _.array(_.string().min(1))
}), Qo = _.array(_.object({
  family: _.string(),
  url: _.string(),
  label: _.string(),
  description: _.string().optional()
})), q = Pt({
  validate: St(Ut),
  initialValues: {
    letters: new Array(3).fill(null)
  }
});
let oe = 0;
const Yo = _.array(_.object({
  character: _.string().url(),
  id: _.string()
})), ti = (t) => {
  const {
    inputElements: e,
    inputEventHandler: s,
    keydownEventHandler: r
  } = Ao({
    length: 3
  });
  return [b(jr, {
    of: q,
    name: "letters",
    children: () => (() => {
      const n = Fo.cloneNode(!0);
      return h(n, b(it, {
        each: e,
        children: (o, i) => b(ft, {
          get name() {
            return `letters.${i()}`;
          },
          of: q,
          children: (l) => (() => {
            const a = Vo.cloneNode(!0), u = a.firstChild;
            h(a, b(K, {
              get when() {
                var c;
                return V(() => !!l.value)() && ((c = t.charactersHTML) == null ? void 0 : c.some((p) => p.id === l.value));
              },
              get children() {
                const c = Eo.cloneNode(!0);
                return D(() => {
                  var p, f;
                  return c.innerHTML = ((f = (p = t.charactersHTML) == null ? void 0 : p.find((w) => w.id === l.value)) == null ? void 0 : f.character) || "";
                }), c;
              }
            }), u), u.$$input = (c) => {
              var f;
              const p = c.currentTarget.value.trim();
              if (p !== "" && !_.string().regex(kn).safeParse(p).success) {
                c.currentTarget.value = l.value && ((f = l.value) == null ? void 0 : f.length) > 1 ? "" : l.value || "";
                return;
              }
              c.currentTarget.value = p, s(c, i()), l.props.onInput(c);
            }, u.$$keydown = (c) => {
              r(c, i(), () => {
                var p;
                !l.value && i() > 0 && ((p = e[i() - 1]) == null ? void 0 : p.value) === "" && ve(q, "letters", {
                  at: i() - 1,
                  value: null
                }), ve(q, "letters", {
                  at: i(),
                  value: null
                });
              });
            };
            const d = e[i()];
            return typeof d == "function" ? Je(d, u) : e[i()] = u, u.addEventListener("focus", () => {
              oe = i();
            }), D(() => {
              var c;
              return Ge(u, `tw-typ-h2-subheading-b tw-relative tw-block tw-h-full tw-w-full tw-bg-transparent tw-text-center tw-uppercase ${l.value && ((c = t.charactersHTML) != null && c.some((p) => p.id === l.value)) ? "tw-ml-[33%]" : ""}`);
            }), D(() => u.value = l.value && (l == null ? void 0 : l.value).length > 1 ? "" : l.value), a;
          })()
        })
      })), n;
    })()
  }), (() => {
    const n = To.cloneNode(!0);
    return h(n, b(it, {
      get each() {
        return t.charactersHTML;
      },
      children: (o, i) => (() => {
        const l = jo.cloneNode(!0);
        return l.$$click = () => {
          var d;
          const a = e[oe];
          a && (a.value = ""), ve(q, "letters", {
            at: oe,
            value: o.id
          });
          const u = Math.min(oe + 1, e.length - 1);
          (d = e[u]) == null || d.focus();
        }, D(() => {
          var a, u;
          return l.innerHTML = ((u = (a = t.charactersHTML) == null ? void 0 : a.find((d) => d.id === o.id)) == null ? void 0 : u.character) || "";
        }), l;
      })()
    })), n;
  })()];
}, ei = (t) => {
  const e = () => M(q, "font", {
    shouldActive: !1,
    shouldDirty: !1,
    shouldTouched: !1
  }) ?? t.fonts[0];
  return (() => {
    const s = Do.cloneNode(!0);
    return h(s, b(ft, {
      of: q,
      name: "font",
      get initialValue() {
        return [e()];
      },
      children: (r) => b(it, {
        get each() {
          return t.fonts;
        },
        children: (n, o) => (() => {
          const i = $n.cloneNode(!0), l = i.firstChild;
          return xe(l, "input", r.props.onInput, !0), l.value = n, h(i, b(Xt, {
            get for() {
              return `customization_drawer_tags_font-id-${o()}`;
            },
            style: {
              "font-family": n
            },
            get children() {
              return b(it, {
                get each() {
                  return t.characters;
                },
                children: (a) => a.length > 1 ? (() => {
                  const u = xn.cloneNode(!0);
                  return u.innerHTML = a, u;
                })() : (() => {
                  const u = Ro.cloneNode(!0);
                  return h(u, a), u;
                })()
              });
            }
          }), null), D((a) => {
            const u = `customization_drawer_tags_font-id-${o()}`, d = r.props.name;
            return u !== a._v$ && G(l, "id", a._v$ = u), d !== a._v$2 && G(l, "name", a._v$2 = d), a;
          }, {
            _v$: void 0,
            _v$2: void 0
          }), D(() => l.checked = r.value === n), i;
        })()
      })
    })), s;
  })();
}, ni = (t) => {
  const e = () => M(q, "color", {
    shouldActive: !1,
    shouldDirty: !1,
    shouldTouched: !1
  }) ?? t.thumbnailAssets[0].value;
  return (() => {
    const s = Lo.cloneNode(!0);
    return h(s, b(it, {
      get each() {
        return t.thumbnailAssets;
      },
      get fallback() {
        return b(pe, {});
      },
      children: (r) => r ? b(ft, {
        name: "color",
        of: q,
        get initialValue() {
          return [e()];
        },
        children: (n) => b(_n, {
          get inputProps() {
            var o, i;
            return {
              type: "radio",
              class: "tw-peer tw-hidden",
              checked: n.value === r.value,
              id: `customization_drawer_tags_color-id-${((o = r.asset) == null ? void 0 : o.id) || ((i = r.asset) == null ? void 0 : i.uri_internal)}`,
              value: r.value,
              ...n.props,
              name: "customization_drawer_tags_color_selector",
              ref: void 0
            };
          },
          get imgProps() {
            var o;
            return {
              src: ((o = r.asset) == null ? void 0 : o.uri_internal) || ""
            };
          }
        })
      }) : null
    })), s;
  })();
}, ri = (t) => {
  const e = () => {
    var s, r, n, o, i;
    return M(q, "productIds", {
      shouldActive: !1,
      shouldDirty: !1,
      shouldTouched: !1
    }) ?? [((i = (o = (n = (r = (s = t.products) == null ? void 0 : s[0]) == null ? void 0 : r.variants) == null ? void 0 : n.nodes) == null ? void 0 : o[0]) == null ? void 0 : i.id) || ""];
  };
  return [(() => {
    const s = Mo.cloneNode(!0);
    return h(s, b(ft, {
      of: q,
      name: "productIds",
      get initialValue() {
        return [e()];
      },
      children: (r) => [b(it, {
        get each() {
          return t.products;
        },
        children: (n, o) => (() => {
          const i = $n.cloneNode(!0), l = i.firstChild;
          return l.$$input = () => {
            var a, u, d;
            t.setView && t.setView(o() === 0 ? "patch" : "tag"), E(q, "productIds", [((d = (u = (a = n == null ? void 0 : n.variants) == null ? void 0 : a.nodes) == null ? void 0 : u[0]) == null ? void 0 : d.id) || ""]);
          }, h(i, b(Xt, {
            get for() {
              return `customization_drawer_tags_product-id-${o()}`;
            },
            get children() {
              const a = He.cloneNode(!0);
              return h(a, () => o() === 0 ? window.customizationProduct.translations.tag["customization-tag-item-3-text-5"] : window.customizationProduct.translations.tag["customization-tag-item-3-text-6"]), a;
            }
          }), null), D((a) => {
            const u = `customization_drawer_tags_product-id-${o()}`, d = r.props.name;
            return u !== a._v$3 && G(l, "id", a._v$3 = u), d !== a._v$4 && G(l, "name", a._v$4 = d), a;
          }, {
            _v$3: void 0,
            _v$4: void 0
          }), D(() => {
            var a, u, d;
            return l.value = (d = (u = (a = n == null ? void 0 : n.variants) == null ? void 0 : a.nodes) == null ? void 0 : u[0]) == null ? void 0 : d.id;
          }), D(() => {
            var a;
            return l.checked = (a = r.value) == null ? void 0 : a.every((u) => {
              var d, c, p;
              return u === ((p = (c = (d = n == null ? void 0 : n.variants) == null ? void 0 : d.nodes) == null ? void 0 : c[0]) == null ? void 0 : p.id);
            });
          }), i;
        })()
      }), (() => {
        const n = Oo.cloneNode(!0), o = n.firstChild;
        return o.$$input = () => {
          var i;
          return E(q, "productIds", ((i = t.products) == null ? void 0 : i.map((l) => {
            var a, u, d;
            return ((d = (u = (a = l == null ? void 0 : l.variants) == null ? void 0 : a.nodes) == null ? void 0 : u[0]) == null ? void 0 : d.id) || "";
          })) || []);
        }, h(n, b(Xt, {
          for: "customization_drawer_tags_product-id-both",
          get children() {
            const i = He.cloneNode(!0);
            return h(i, () => window.customizationProduct.translations.tag["customization-tag-item-3-text-7"]), i;
          }
        }), null), D(() => G(o, "name", r.props.name)), D(() => {
          var i;
          return o.checked = ((i = r.value) == null ? void 0 : i.length) === 2;
        }), n;
      })()]
    })), s;
  })(), (() => {
    const s = Bo.cloneNode(!0);
    return h(s, () => window.customizationProduct.translations.tag["customization-tag-item-3-text-4"]), s;
  })()];
}, si = (t) => t.endsWith("/") ? t.slice(0, -1) : t, oi = () => {
  var S, j, H, X, N, T;
  st(q, {
    initialValues: {
      ...Rt(C, {
        shouldActive: !1,
        shouldDirty: !1,
        shouldTouched: !1,
        shouldValid: !1
      }).tags,
      productIds: ((S = M(C, "tags.productIds", {
        shouldActive: !1,
        shouldDirty: !1,
        shouldTouched: !1,
        shouldValid: !1
      })) == null ? void 0 : S.map((m) => `gid://shopify/ProductVariant/${m}`)) || [],
      letters: ((j = M(C, "tags.letters", {
        shouldActive: !1,
        shouldDirty: !1,
        shouldTouched: !1,
        shouldValid: !1
      })) == null ? void 0 : j.map((m) => m.split("-")[1])) ?? [null, null, null]
    }
  }), At(window.customizationProduct.translations.tittles["tag-title"]);
  const [t] = zt(), [e, s] = O("patch"), r = on(), n = ee(), o = dt(), i = V(() => si(n.pathname).split("/").slice(0, -1).join("/")), l = () => {
    var m, x, z;
    return It((z = (x = (m = t()) == null ? void 0 : m.collection) == null ? void 0 : x.metafield) == null ? void 0 : z.value, "collection");
  }, a = V(() => {
    var z, R, B;
    const m = l();
    if (!(m != null && m.success))
      return [];
    const x = (B = (R = (z = m == null ? void 0 : m.data) == null ? void 0 : z.category_attributes) == null ? void 0 : R.find((A) => A.slug === "available-colors")) == null ? void 0 : B.value;
    try {
      return Qe.parse(JSON.parse(x || "[]")).map((A) => {
        var L, W;
        return {
          asset: (W = (L = m == null ? void 0 : m.data) == null ? void 0 : L.assets) == null ? void 0 : W.find((Q) => {
            var tt;
            return (tt = Q.tags) == null ? void 0 : tt.split(",").some((nt) => nt === `color-image-thumbnail:${A.value}`);
          }),
          ...A
        };
      }).filter(Boolean);
    } catch (A) {
      return console.error("Error parsing available colors", A), null;
    }
  }), u = V(() => {
    var R, B, A;
    const m = l();
    if (!m.success)
      return null;
    const x = m.success && ((A = (B = (R = m.data) == null ? void 0 : R.category_attributes) == null ? void 0 : B.find((L) => L.slug === "available_fonts")) == null ? void 0 : A.value), z = Qo.safeParse(JSON.parse(x || "[]"));
    return z.success ? z.data : null;
  }), d = () => {
    var R, B;
    const m = l();
    if (!(m != null && m.success) || !(Number(((R = m == null ? void 0 : m.data.category_attributes) == null ? void 0 : R.length) || 0) > 0))
      return [];
    const x = (B = m == null ? void 0 : m.data.category_attributes) == null ? void 0 : B.find((A) => (A == null ? void 0 : A.slug) === "available-characters"), z = Yo.safeParse(JSON.parse((x == null ? void 0 : x.value) || "[]"));
    return z.success ? z.data : null;
  }, [c] = Ln(d, (m) => Promise.all(m.map((x) => fetch(x.character).then((z) => z.text()).then((z) => ({
    character: z.replaceAll(/fill=".*?"/g, 'fill="currentColor"'),
    id: x.id
  }))))), p = () => {
    var B, A, L;
    const m = (L = (A = (B = t()) == null ? void 0 : B.collection) == null ? void 0 : A.products) == null ? void 0 : L.nodes;
    if (!m)
      return null;
    const x = m == null ? void 0 : m.map((W) => {
      var tt;
      const Q = It((tt = W == null ? void 0 : W.metafield) == null ? void 0 : tt.value, "p_attributes");
      return {
        ...W,
        metafield: {
          value: Q.success ? Q.data : null
        }
      };
    }), z = x == null ? void 0 : x.find((W) => {
      var Q, tt, nt;
      return ((nt = (tt = (Q = W.metafield) == null ? void 0 : Q.value) == null ? void 0 : tt.find((lt) => lt.slug === "customization-type")) == null ? void 0 : nt.value) === "custom-patch";
    }), R = x == null ? void 0 : x.find((W) => {
      var Q, tt, nt;
      return ((nt = (tt = (Q = W.metafield) == null ? void 0 : Q.value) == null ? void 0 : tt.find((lt) => lt.slug === "customization-type")) == null ? void 0 : nt.value) === "custom-tags";
    });
    return [z, R];
  }, f = () => {
    var W, Q, tt, nt, lt, wt, F, J, et, rt;
    const m = l(), x = xt.currentProductAttributes(), z = xt.currentProductAssets();
    if (!m.success && !x.success && !z.success)
      return null;
    const R = (m == null ? void 0 : m.success) && ((tt = (Q = (W = m.data) == null ? void 0 : W.assets) == null ? void 0 : Q.find((U) => {
      var Z;
      return (Z = U.tags) == null ? void 0 : Z.split(",").includes("category-base-product-image-with-zoom-tag");
    })) == null ? void 0 : tt.uri_internal), B = (z == null ? void 0 : z.success) && ((lt = (nt = z.data) == null ? void 0 : nt.find((U) => (U == null ? void 0 : U.type) === "product_base_product_image_with_zoom_tag")) == null ? void 0 : lt.uri_internal), A = m.success && ((J = (F = (wt = m.data) == null ? void 0 : wt.category_attributes) == null ? void 0 : F.find((U) => U.slug === "customization_imagen_zoom_position")) == null ? void 0 : J.value), L = (x == null ? void 0 : x.success) && ((rt = (et = x == null ? void 0 : x.data) == null ? void 0 : et.find((U) => U.slug === "customization_image_zoom_position_tag")) == null ? void 0 : rt.value);
    return L && B ? {
      position: L,
      image: B
    } : R && A ? {
      position: A,
      image: R
    } : {
      position: null,
      image: null
    };
  }, w = () => {
    var W, Q, tt, nt, lt, wt, F, J, et, rt;
    const m = l(), x = xt.currentProductAttributes(), z = xt.currentProductAssets();
    if (!m.success && !x.success && !z.success)
      return null;
    const R = (m == null ? void 0 : m.success) && ((tt = (Q = (W = m.data) == null ? void 0 : W.assets) == null ? void 0 : Q.find((U) => {
      var Z;
      return (Z = U.tags) == null ? void 0 : Z.split(",").includes("category-base-product-image-with-zoom-patch");
    })) == null ? void 0 : tt.uri_internal), B = (z == null ? void 0 : z.success) && ((lt = (nt = z.data) == null ? void 0 : nt.find((U) => (U == null ? void 0 : U.type) === "product_base_product_image_with_zoom_patch")) == null ? void 0 : lt.uri_internal), A = m.success && ((J = (F = (wt = m.data) == null ? void 0 : wt.category_attributes) == null ? void 0 : F.find((U) => U.slug === "customization_imagen_zoom_position")) == null ? void 0 : J.value), L = (x == null ? void 0 : x.success) && ((rt = (et = x == null ? void 0 : x.data) == null ? void 0 : et.find((U) => U.slug === "customization_image_zoom_position_patch")) == null ? void 0 : rt.value);
    return L && B ? {
      position: L,
      image: B
    } : R && A ? {
      position: A,
      image: R
    } : {
      position: null,
      image: null
    };
  }, g = () => {
    var m, x;
    return ((x = (m = Rt(q, {
      shouldActive: !1
    })) == null ? void 0 : m.letters) == null ? void 0 : x.map((z) => {
      var R, B;
      return (z && (z == null ? void 0 : z.length) > 1 ? ((B = (R = c()) == null ? void 0 : R.find((A) => A.id === z)) == null ? void 0 : B.character) || "" : z) || "";
    })) || [];
  };
  he(() => {
    var m;
    Xo(((m = c()) == null ? void 0 : m.map((x) => x.id)) || []);
  }), he(() => {
    var x, z;
    const m = (z = (x = a()) == null ? void 0 : x[0]) == null ? void 0 : z.value;
    m && !M(q, "color", {
      shouldActive: !1
    }) && E(q, "color", m);
  }), he(() => {
    var x, z;
    const m = (z = (x = u()) == null ? void 0 : x[0]) == null ? void 0 : z.family;
    m && !M(q, "font", {
      shouldActive: !1
    }) && E(q, "font", m);
  });
  const v = [{
    title: window.customizationProduct.translations.tag["customization-tag-item-1-text-1"],
    description: window.customizationProduct.translations.tag["customization-tag-item-1-text-2"],
    valid: () => Ut.shape.letters.safeParse(Rt(q, {
      shouldActive: !1,
      shouldDirty: !1,
      shouldTouched: !1
    }).letters).success
  }, {
    title: window.customizationProduct.translations.tag["customization-tag-item-2-text-1"],
    description: (X = (H = u()) == null ? void 0 : H.find((m) => m.family === M(q, "font"))) == null ? void 0 : X.description,
    valid: () => Ut.shape.font.safeParse(M(q, "font")).success
  }, {
    title: window.customizationProduct.translations.tag["customization-tag-item-4-text-1"],
    description: (T = (N = a()) == null ? void 0 : N.find((m) => m.value === M(q, "color"))) == null ? void 0 : T.name,
    valid: () => Ut.shape.color.safeParse(M(q, "color")).success
  }, {
    title: window.customizationProduct.translations.tag["customization-tag-item-3-text-1"],
    description: window.customizationProduct.translations.tag["customization-tag-item-3-text-2"],
    valid: () => Ut.shape.productIds.safeParse(M(q, "productIds")).success
  }], k = V(() => v[Number(r.id) - 1]), I = () => v.length === Number(r.id), P = V(() => I() ? "/" : `${i()}/${Number(r.id) + 1}`);
  return b(Ct, {
    of: q,
    onSubmit: (m, x) => {
      var A;
      if (((A = x.submitter) == null ? void 0 : A.getAttribute("type")) !== "submit") {
        C.internal.setSubmitted(!1);
        return;
      }
      const R = m.productIds.map((L) => kt(L)), B = m.letters.map((L) => {
        var W;
        return L && (L == null ? void 0 : L.length) > 1 && ((W = c()) != null && W.find((Q) => Q.id === L)) ? `char-${L}` : `letter-${L}`;
      });
      E(C, "tags.productIds", R, {
        shouldValidate: !1
      }), E(C, "tags.font", m.font, {
        shouldValidate: !1
      }), E(C, "tags.color", m.color, {
        shouldValidate: !1
      }), E(C, "tags.letters", B, {
        shouldValidate: !1
      }), o("/");
    },
    class: "tw-h-full",
    shouldActive: !1,
    get children() {
      return [b(it, {
        get each() {
          return u();
        },
        children: (m) => b(K, {
          get when() {
            return m.url.startsWith("https://fonts.google");
          },
          get fallback() {
            return (() => {
              const x = Uo.cloneNode(!0);
              return h(x, () => `
              @font-face {
                font-family: '${m.family}';
                font-style: normal;
                font-weight: 400;
                src: url('${m.url}') format('woff2');
              }
            `), x;
            })();
          },
          get children() {
            return b(vn, {
              get href() {
                return `${m.url}`;
              },
              rel: "stylesheet"
            });
          }
        })
      }), (() => {
        const m = qo.cloneNode(!0), x = m.firstChild, z = x.firstChild, R = z.firstChild, B = R.nextSibling, A = z.nextSibling, L = A.firstChild, W = L.firstChild, Q = W.firstChild, tt = Q.nextSibling;
        tt.nextSibling;
        const nt = W.nextSibling, lt = nt.nextSibling, wt = x.nextSibling;
        return h(R, () => ["patch", "tag"].map((F, J) => (() => {
          const et = Ko.cloneNode(!0), rt = et.firstChild, U = rt.nextSibling;
          return rt.$$input = () => {
            s(F);
          }, G(rt, "id", `customization-tags-view-selector-${F}`), G(U, "for", `customization-tags-view-selector-${F}`), h(U, () => F === "tag" ? window.customizationProduct.translations.tag["customization-tag-view-toggle-tag"] : window.customizationProduct.translations.tag["customization-tag-view-toggle-patch"]), D(() => rt.checked = F === e()), et;
        })())), h(B, b(Bt, mt(() => {
          var F, J, et, rt;
          return e() === "tag" ? {
            background: ((F = f()) == null ? void 0 : F.image) || "",
            location: ((J = f()) == null ? void 0 : J.position) || "center-center"
          } : {
            background: ((et = w()) == null ? void 0 : et.image) || "",
            location: ((rt = w()) == null ? void 0 : rt.position) || "center-center"
          };
        }, {
          get children() {
            const F = Ho.cloneNode(!0);
            return h(F, b(it, {
              get each() {
                return g();
              },
              children: (J) => J.length > 1 ? (() => {
                const et = xn.cloneNode(!0);
                return et.innerHTML = J, et;
              })() : (() => {
                const et = Jo.cloneNode(!0);
                return h(et, J), et;
              })()
            })), D((J) => {
              var U, Z, Y, ht, Wt, ne;
              const et = M(q, "font", {
                shouldActive: !1
              }), rt = (M(q, "color", {
                shouldActive: !1
              }) ? ((Z = (U = a()) == null ? void 0 : U.find((we) => we.value === M(q, "color", {
                shouldActive: !1
              }))) == null ? void 0 : Z.hex) || ((ht = (Y = a()) == null ? void 0 : Y[0]) == null ? void 0 : ht.hex) : (ne = (Wt = a()) == null ? void 0 : Wt[0]) == null ? void 0 : ne.hex) || "#FFF";
              return et !== J._v$5 && F.style.setProperty("font-family", J._v$5 = et), rt !== J._v$6 && F.style.setProperty("color", J._v$6 = rt), J;
            }, {
              _v$5: void 0,
              _v$6: void 0
            }), F;
          }
        }))), h(W, (() => {
          const F = V(() => !!r.id);
          return () => F() ? Number(r.id) : 1;
        })(), Q), h(W, () => window.customizationProduct.translations.customization["customization-text-of"], tt), h(W, () => v.length, null), h(nt, () => {
          var F;
          return (F = v[Number(r.id) - 1]) == null ? void 0 : F.title;
        }), h(lt, () => {
          var F;
          return (F = v[Number(r.id) - 1]) == null ? void 0 : F.description;
        }), h(A, b(Ze, {
          get children() {
            return [b(jt, {
              get when() {
                return Number(r.id) === 1;
              },
              get children() {
                return b(ti, {
                  get charactersHTML() {
                    return c() || [];
                  }
                });
              }
            }), b(jt, {
              get when() {
                return Number(r.id) === 2;
              },
              get children() {
                return b(ei, {
                  get characters() {
                    return g();
                  },
                  get fonts() {
                    var F;
                    return ((F = u()) == null ? void 0 : F.map((J) => J.family)) || [];
                  }
                });
              }
            }), b(jt, {
              get when() {
                return Number(r.id) === 3;
              },
              get children() {
                return b(ni, {
                  get thumbnailAssets() {
                    return a() || [];
                  }
                });
              }
            }), b(jt, {
              get when() {
                return Number(r.id) === 4;
              },
              get children() {
                return b(ri, {
                  get products() {
                    return p() || [];
                  },
                  setView: s
                });
              }
            })];
          }
        }), null), h(wt, b(K, {
          get when() {
            return !I();
          },
          get fallback() {
            return (() => {
              const F = Go.cloneNode(!0);
              return h(F, () => window.customizationProduct.translations.buttons["customization-apply-button"]), D(() => F.disabled = q.invalid), F;
            })();
          },
          get children() {
            const F = Wo.cloneNode(!0);
            return F.$$click = () => {
              o(P());
            }, h(F, () => window.customizationProduct.translations.buttons["customization-next-button"]), D(() => {
              var J;
              return F.disabled = !((J = k()) != null && J.valid());
            }), F;
          }
        }), null), h(wt, b(K, {
          get when() {
            return Number(r.id) !== 1;
          },
          get fallback() {
            return (() => {
              const F = We.cloneNode(!0);
              return F.$$click = () => {
                o("/");
              }, h(F, () => window.customizationProduct.translations.buttons["customization-button-cancel"]), F;
            })();
          },
          get children() {
            const F = We.cloneNode(!0);
            return F.$$click = () => {
              o(-1);
            }, h(F, () => window.customizationProduct.translations.buttons["customization-previous-button"]), F;
          }
        }), null), m;
      })()];
    }
  });
};
yt(["keydown", "input", "click"]);
const qe = _.string().or(_.number()).or(_.boolean()).or(_.null()), ii = qe.or(_.array(qe)), ai = _.string(), In = _.lazy(
  () => _.record(ai, ii.or(In))
), li = _.array(
  _.object({
    id: _.number(),
    quantity: _.number(),
    properties: In
  }).nullable()
), zn = async (t) => (await _.array(_.string()).parseAsync(t), fetch("/cart/update.js", {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify({
    updates: t.reduce((s, r) => (s[r] = 0, s), {})
  })
}).then((s) => s.json())), ci = async (t, e = () => {
}) => {
  const s = await li.parseAsync(t);
  return await e(), fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      items: s
    })
  }).then((r) => r.json());
}, ui = Kn`
  query CustomizationCollection($handle: String!) {
    collection(handle: $handle) {
      metafield(namespace: "_jasper_", key: "category_json") {
        key
        value
      }
      products(first: 250) {
        nodes {
          featuredImage {
            url
          }
          id
          title
          handle
          variants(first: 1) {
            nodes {
              title
              availableForSale
              id
              price {
                amount
                currencyCode
              }
            }
          }
          metafield(namespace: "_jasper_", key: "jp_attributes") {
            key
            value
          }
        }
      }
    }
  }
`.replaceAll("_jasper_", window.storefrontApi.jasperChannel), Vt = (t) => () => Jn(ui, { handle: t }), di = (t) => {
  const e = () => t().map((s) => dr(() => s)());
  return [e, () => e().some(Boolean)];
}, pi = /* @__PURE__ */ y('<button class="tw-w-1/6"></button>'), gi = /* @__PURE__ */ y('<div class="tw-flex tw-justify-between tw-bg-box-background tw-p-10"><h5 class="tw-typ-h3-subtopic-1-a tw-w-4/6"></h5><button class="tw-w-1/6"></button></div>'), mi = /* @__PURE__ */ y('<div class="tw-px-10 tw-py-2"></div>'), fi = /* @__PURE__ */ y('<div class="tw-custom-scrollbar tw-mb-10 tw-h-full tw-overflow-y-auto tw-px-10 tw-pt-3"></div>'), wi = /* @__PURE__ */ y('<div class="tw-flex tw-h-full tw-items-center tw-justify-center tw-p-10"></div>'), Sn = [{
  path: "/monograms",
  component: Ms,
  data: Vt("custom-monograms"),
  children: [{
    path: "/",
    element: () => (dt()("/monograms/1", {
      replace: !0
    }), null)
  }, {
    path: "/:id",
    component: Ls
  }]
}, {
  path: "/engraving",
  element: ao,
  data: Vt("custom-engraving")
}, {
  path: "/stickers",
  data: () => [Vt("custom-stickers-single"), Vt("custom-stickers-bundle")],
  children: [{
    path: "/",
    element: po
  }, {
    path: "/single",
    component: No
  }, {
    path: "/bundle",
    component: yo
  }]
}, {
  path: "/tags",
  data: Vt("custom-tags"),
  children: [{
    path: "/",
    element: () => (dt()("/tags/1", {
      replace: !0
    }), null)
  }, {
    path: "/:id",
    component: oi
  }]
}, {
  path: "/gift-wrap",
  element: hs,
  data: Vt("custom-gift-wrap")
}], hi = {
  "/monograms": window.customizationProduct.translations.tittles["monogram-tittle"],
  "/engraving": window.customizationProduct.translations.tittles["engraving-title"],
  "/stickers": window.customizationProduct.translations.tittles["stickers-title"],
  "/tags": window.customizationProduct.translations.tittles["tag-title"],
  "/gift-wrap": window.customizationProduct.translations.tittles["gif-title"]
}, bi = Sn.map((t) => ({
  path: t.path
})), _i = {
  monogram: "monogram",
  giftWrap: "gift_wrap",
  singleStickers: "stickers_single",
  bundleStickers: "stickers_bundle",
  tags: "tags",
  engraving: "engraving"
}, vi = ["/monograms/:id", "/stickers/bundle", "/stickers/single"], yi = () => {
  const [t, e] = di(() => vi), s = dt(), r = ee(), n = _r(Sn), o = async (i, l) => {
    var k, I, P, $, S, j, H, X, N, T, m, x, z, R, B, A, L, W, Q, tt, nt, lt, wt, F, J, et, rt, U;
    if (((k = l.submitter) == null ? void 0 : k.getAttribute("type")) !== "submit") {
      st(C, {
        keepDirty: !0,
        keepDirtyItems: !0,
        keepDirtyValues: !0,
        keepErrors: !0,
        keepTouched: !0,
        keepItems: !0,
        keepResponse: !0,
        keepValues: !0
      });
      return;
    }
    const u = (P = (I = Dt().product) == null ? void 0 : I.variants) == null ? void 0 : P.nodes[0].id;
    if (!u)
      throw new Error("No variant id found");
    const d = Number(kt(u)), {
      customizationProductId: c,
      ...p
    } = i, f = Object.entries(p), w = [...($ = i.monogram) != null && $.productIds && ((j = (S = i.monogram) == null ? void 0 : S.productIds) == null ? void 0 : j.length) > 0 ? (X = (H = i.monogram) == null ? void 0 : H.productIds) == null ? void 0 : X.map((Z) => {
      var Y;
      return {
        id: Number(Z),
        quantity: 1,
        properties: {
          _related_customization_product_id: c,
          _personalization_id: (Y = i.monogram) == null ? void 0 : Y.personalizationId
        }
      };
    }) : [null], ...(N = i.giftWrap) != null && N.productIds && ((T = i.giftWrap) == null ? void 0 : T.productIds.length) > 0 ? (x = (m = i.giftWrap) == null ? void 0 : m.productIds) == null ? void 0 : x.map((Z) => {
      var Y;
      return {
        id: Number(Z),
        quantity: 1,
        properties: {
          _related_customization_product_id: c,
          _personalization_id: (Y = i.giftWrap) == null ? void 0 : Y.personalizationId
        }
      };
    }) : [null], ...(z = i.engraving) != null && z.productIds && ((R = i.engraving) == null ? void 0 : R.productIds.length) > 0 ? (A = (B = i.engraving) == null ? void 0 : B.productIds) == null ? void 0 : A.map((Z) => {
      var Y;
      return {
        id: Number(Z),
        quantity: 1,
        properties: {
          _related_customization_product_id: c,
          _personalization_id: (Y = i.engraving) == null ? void 0 : Y.personalizationId,
          _customization_properties: {
            font_id: i.engraving.fontFamily,
            engraving_text: i.engraving.textContent
          }
        }
      };
    }) : [null], ...(L = i.singleStickers) != null && L.productIds && ((W = i.singleStickers) == null ? void 0 : W.productIds.length) > 0 ? (tt = (Q = i.singleStickers) == null ? void 0 : Q.productIds) == null ? void 0 : tt.map((Z) => {
      var Y;
      return {
        id: Number(Z),
        quantity: 1,
        properties: {
          _related_customization_product_id: c,
          _personalization_id: (Y = i.singleStickers) == null ? void 0 : Y.personalizationId
        }
      };
    }) : [null], ...(nt = i.bundleStickers) != null && nt.productIds && ((lt = i.bundleStickers) == null ? void 0 : lt.productIds.length) > 0 ? (F = (wt = i.bundleStickers) == null ? void 0 : wt.productIds) == null ? void 0 : F.map((Z) => {
      var Y;
      return {
        id: Number(Z),
        quantity: 1,
        properties: {
          _related_customization_product_id: c,
          _personalization_id: (Y = i.bundleStickers) == null ? void 0 : Y.personalizationId
        }
      };
    }) : [null], ...(J = i.tags) != null && J.productIds && ((et = i.tags) == null ? void 0 : et.productIds.length) > 0 ? (U = (rt = i.tags) == null ? void 0 : rt.productIds) == null ? void 0 : U.map((Z) => {
      var Y, ht;
      return {
        id: Number(Z),
        quantity: 1,
        properties: {
          _related_customization_product_id: c,
          _personalization_id: (Y = i.tags) == null ? void 0 : Y.personalizationId,
          _customization_properties: {
            font_id: i.tags.font,
            color_id: i.tags.color,
            ...(ht = i.tags.letters) == null ? void 0 : ht.reduce((Wt, ne, we) => (Wt[`character_${we + 1}`] = ne, Wt), {})
          }
        }
      };
    }) : [null]].filter(Boolean), g = [{
      id: d,
      quantity: 1,
      properties: w.length === 0 ? {} : {
        _customization_product_id: i.customizationProductId,
        ...Object.fromEntries(f.filter(([Z, Y]) => w.some((ht) => (ht == null ? void 0 : ht.properties._personalization_id) === Y.personalizationId)).map(([Z, Y]) => {
          const ht = _i[Z];
          return Z ? ["_p_" + ht, Y.personalizationId] : [];
        }))
      }
    }, ...w.length === 0 ? [] : w], v = at(Wr);
    await ci(g, v && v.length > 0 ? () => zn(v) : () => {
    }).catch((Z) => {
      console.error(Z);
    }), window.location.replace("/cart");
  };
  return b(K, {
    get when() {
      return Dt();
    },
    get fallback() {
      return (() => {
        const i = wi.cloneNode(!0);
        return h(i, b(pe, {})), i;
      })();
    },
    get children() {
      return b(Ct, {
        shouldActive: !1,
        class: "tw-flex tw-h-full tw-flex-col tw-justify-between",
        of: C,
        onSubmit: o,
        noValidate: !0,
        get children() {
          return [(() => {
            const i = gi.cloneNode(!0), l = i.firstChild, a = l.nextSibling;
            return h(i, b(K, {
              get when() {
                return r.pathname !== "/";
              },
              get children() {
                const u = pi.cloneNode(!0);
                return u.$$click = () => s("/"), h(u, b(Os, {
                  class: "tw-inline-block tw-h-5 tw-w-5"
                })), u;
              }
            }), l), h(l, Rr), a.$$click = () => ae("close"), h(a, b(Ws, {
              class: "tw-inline-block tw-h-5 tw-w-5"
            })), i;
          })(), b(K, {
            get when() {
              return e();
            },
            get children() {
              const i = mi.cloneNode(!0);
              return h(i, b($r, {})), i;
            }
          }), (() => {
            const i = fi.cloneNode(!0);
            return h(i, b(n, {}), null), h(i, b(cn, {
              get children() {
                return b(vr, {
                  path: "/",
                  component: () => b(as, {
                    routesTitle: hi,
                    rootLevelRoutesPaths: bi
                  })
                });
              }
            }), null), i;
          })()];
        }
      });
    }
  });
};
yt(["click"]);
function $i(t) {
  try {
    return document.querySelector(t);
  } catch {
    return null;
  }
}
function xi(t, e) {
  const s = $i(`#${t}`);
  s ? s.scrollIntoView() : e && window.scrollTo(0, 0);
}
const ki = () => {
  const t = ["/"];
  let e = 0;
  const s = [], r = (n) => {
    e = Math.max(0, Math.min(e + n, t.length - 1));
    const o = t[e];
    s.forEach((i) => i(o));
  };
  return {
    get: () => t[e],
    set: ({ value: n, scroll: o, replace: i }) => {
      i ? t[e] = n : (t.splice(e + 1, t.length - e, n), e++), o && xi(n.split("#")[1] || "", !0);
    },
    back: () => {
      r(-1);
    },
    forward: () => {
      r(1);
    },
    go: r,
    listen: (n) => (s.push(n), () => {
      const o = s.indexOf(n);
      s.splice(o, 1);
    })
  };
}, Ii = () => {
  const t = ki();
  return tn(
    t.get,
    t.set,
    t.listen,
    {
      go: t.go
    }
  );
}, zi = /* @__PURE__ */ y('<div class="tw-flex tw-h-full tw-items-center tw-justify-center tw-p-10"></div>');
window.customization = {};
const Si = document.getElementById("customization-drawer-overlay"), Pn = () => document.querySelectorAll("[data-action='open-customization-drawer']"), Ee = _.object({
  _related_customization_product_id: _.string(),
  _personalization_id: _.string()
}), Nn = Ee.extend({
  _customization_properties: _.object({
    font_id: _.string(),
    color_id: _.string(),
    character_1: _.string().optional(),
    character_2: _.string().optional(),
    character_3: _.string().optional()
  })
}), Cn = Ee.extend({
  _customization_properties: _.object({
    engraving_text: _.string(),
    font_id: _.string()
  })
}), Pi = _.object({
  _customization_product_id: _.string(),
  _p_monogram: _.string().optional(),
  _p_gift_wrap: _.string().optional(),
  _p_engraving: _.string().optional(),
  _p_tags: _.string().optional(),
  _p_stickers_bundle: _.string().optional(),
  _p_stickers_single: _.string().optional()
}), Ni = _.object({
  items: _.array(_.object({
    id: _.number().transform(String),
    key: _.string(),
    properties: _.union([Cn, Nn, Ee, Pi, _.record(_.string(), _.any())]),
    variant_id: _.number().transform(String)
  }).partial())
}), Ci = {
  _p_monogram: "monogram",
  _p_gift_wrap: "giftWrap",
  _p_stickers_bundle: "bundleStickers",
  _p_stickers_single: "singleStickers",
  _p_engraving: "engraving",
  _p_tags: "tags"
}, [Ai, Ue] = O(!1), [Ti, Fi] = O([...Pn()]);
window.customization.removeFromCart = async (t, {
  onRemove: e = () => {
  },
  onError: s = () => {
  }
}) => {
  await zn(t).then(() => {
    e();
  }).catch((r) => {
    s(r);
  });
};
const Ei = () => Fi([...Pn()]);
window.customization.refreshOpenDrawerButtons = Ei;
async function Vi(t) {
  const e = await fetch("/cart.js").then((a) => a.json()), s = Ni.safeParse(e);
  if (!s.success) {
    console.error(s.error);
    return;
  }
  const r = s.data.items.find((a) => (a == null ? void 0 : a.properties) && "_customization_product_id" in a.properties && a.properties._customization_product_id === t);
  if (!r) {
    console.error("Base product not found");
    return;
  }
  const n = s.data.items.filter((a) => (a == null ? void 0 : a.properties) && "_related_customization_product_id" in a.properties && a.properties._related_customization_product_id === t), o = _.array(_.string()).safeParse([...n.map((a) => a.key), r.key]), i = n == null ? void 0 : n.reduce((a, u) => {
    var f, w;
    const [d] = Object.entries(r.properties).find(([g, v]) => u.properties._personalization_id === v) || [];
    if (!d)
      return a;
    const c = Ci[d];
    let p = {};
    if (c === "tags") {
      const g = a[c] || {}, v = Nn.safeParse(u.properties);
      if (!v.success)
        return a;
      p = {
        font: g.font ?? v.data._customization_properties.font_id,
        color: g.color ?? v.data._customization_properties.color_id,
        letters: g.letters ?? [v.data._customization_properties.character_1, v.data._customization_properties.character_2, v.data._customization_properties.character_3]
      };
    }
    if (c === "engraving") {
      const g = a[c] || {}, v = Cn.safeParse(u.properties);
      if (!v.success)
        return a;
      p = {
        fontFamily: g.fontFamily || v.data._customization_properties.font_id,
        textContent: g.textContent || v.data._customization_properties.engraving_text
      };
    }
    return {
      ...a,
      [c]: {
        personalizationId: ((f = a[c]) == null ? void 0 : f.personalizationId) || u.properties._personalization_id,
        productIds: [...((w = a[c]) == null ? void 0 : w.productIds) || [], u.variant_id],
        ...p
      }
    };
  }, {});
  Ie(o.success ? o.data : []);
  const l = {
    ...bn(),
    customizationProductId: t,
    ...i
  };
  st(C, {
    initialValues: l
  }), wn(C, l);
}
const ji = () => {
  const t = dt();
  return Ht(() => {
    Ti().forEach((e) => {
      e.addEventListener("click", () => {
        ae("open"), Ie([]);
        const s = e.getAttribute("data-customization-id"), r = e.getAttribute("data-handle-product"), n = e.getAttribute("data-relation-id"), o = e.getAttribute("data-cart-key");
        r && Wn(r), s && t(`/${s}`), !n && o && Ie([o]), n && (Ue(!0), Vi(n).finally(() => {
          Ue(!1);
        }));
      });
    });
  }), Si.addEventListener("click", () => {
    ae("close");
  }), null;
}, Di = () => () => b(Us, {
  get children() {
    return b(br, {
      get source() {
        return Ii();
      },
      get children() {
        return b(Bn, {
          get fallback() {
            return (() => {
              const t = zi.cloneNode(!0);
              return h(t, b(pe, {})), t;
            })();
          },
          get children() {
            return [b(ji, {}), b(K, {
              get when() {
                return V(() => Hn() !== "")() && !Ai();
              },
              get children() {
                return b(yi, {});
              }
            })];
          }
        });
      }
    });
  }
});
Mn(Di, document.getElementById("customization-drawer-content"));
export {
  Ni as cartResponseSchema
};
